<template>
  <div class="p_resource_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">姓名</div>
                    <el-input v-model="listQuery.strUserName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <div class="flname">联系方式</div>
                    <el-input v-model="listQuery.strMobile" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                  <div class="flname">人岗匹配岗位</div>
                  <el-select v-model="listQuery.strpsnJob" @change="psnJobChange" ref="matchRef" size="small" filterable clearable placeholder="">
                    <el-option
                        v-for="(item, index) in postList"
                        :key="index"
                        :label="item.StrprojectName+'/'+item.CustomerJobName"
                        :value="item.Id">
                      </el-option>
                  </el-select>
                </div>
                <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- <el-collapse-transition> -->
      <!-- 筛选下拉框 -->
      <div class="r_dropDownScreen" v-show="showDropScreen==1">
        <div class="pro_down_box">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="求职意向:">
              <el-select filterable v-model="listQuery.strUserJobhunt" placeholder="" size="small" clearable>
                <el-option label="在找工作" value="在找工作"></el-option>
                <el-option label="有工作考虑新机会" value="有工作考虑新机会"></el-option>
                <el-option label="不找工作" value="不找工作"></el-option>
                <el-option label="未知" value="未知"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别:">
              <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
                <el-option label="女" value="女"></el-option>
                <el-option label="男" value="男"></el-option>
                <el-option label="不限" value="不限"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年龄:">
              <div class="r_line_box">
                <el-input v-model="listQuery.strUserAgeb" size="small" type="number" oninput="value=value.replace(/\D+/g,'')" min="0" clearable class="r_line_input1"></el-input>
                <span class="r_line_txt"></span>
                <el-input v-model="listQuery.strUserAgee" size="small" type="number" oninput="value=value.replace(/\D+/g,'')" min="0" clearable class="r_line_input2"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="意向地区:">
              <el-cascader :props="propsAddress" filterable ref="cascaderSearArr" size="small" v-model="listQuery.strCityCode" :options="provinces" @change="changeSearchArea"></el-cascader>
            </el-form-item>
            <el-form-item label="意向岗位:">
              <el-cascader ref="poSearchArr" size="small" placeholder=""
              v-model="listQuery.posCategoryList" :props="propPosition" clearable
              :options="intendedPost"
              @change="poSearchChange"></el-cascader>
            </el-form-item>
            <el-form-item label="期望薪资:">
              <div class="r_line_box">
                <el-input v-model="listQuery.strUserExpectSab" size="small" type="number" min="0" clearable class="r_line_input1"></el-input>
                <span class="r_line_txt"></span>
                <el-input v-model="listQuery.strUserExpectSae" size="small" type="number" min="0" clearable class="r_line_input2"></el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item label="当前状态:" class="f_all_width">
              <div class="r_more_box">
                <el-checkbox-group v-model="statusCheckList" class="f_checks_box">
                  <el-checkbox :label="item.Name" v-for="(item,index) in statusList" :key="index" v-show="showMore1 ? index < 10 : index + 1"></el-checkbox>
                </el-checkbox-group>
                <div class="r_more_txt" v-if="statusList.length > 10" @click="showMore1 = !showMore1">
                  <span>{{showMore1 ? '更多':'收起'}}</span>
                  <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore1 }"></i>
                </div>
              </div>
            </el-form-item> -->
            <el-form-item label="包含标签" class="f_all_width">
              <div class="r_search_box">
                <div class="r_search_sel" @click="cludeHandle">
                  <p class="r_search_txt" :title="searchQuery.includeContent">{{searchQuery.includeContent}}</p>
                  <i class="el-icon-caret-bottom"></i>
                </div>
                <div class="r_more_box">
                  <p style="margin-left:8px;margin-right:5px;">常用标签:</p>
                  <el-checkbox-group v-model="includeLabelChecks" class="f_checks_box" v-if="showMore2">
                    <el-checkbox :label="item.LabelId" v-for="(item,index) in includeLabelList" :key="index" v-show="showMore2 ? index < 10 : index + 1">
                      <span>{{item.LableName}}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- <div class="r_more_txt" v-if="includeLabelList.length > 0" @click="cludeHandle">
                    <span>更多</span>
                    <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore2 }"></i>
                  </div> -->
                </div>
              </div>
            </el-form-item>
            <el-form-item label="排除标签" class="f_all_width">
              <div class="r_search_box">
                <div class="r_search_sel" @click="excludeHandle">
                  <p class="r_search_txt" :title="searchQuery.encludeContent">{{searchQuery.encludeContent}}</p>
                  <i class="el-icon-caret-bottom"></i>
                </div>
                <div class="r_more_box">
                  <p style="margin-left:8px;margin-right:5px;">常用标签:</p>
                  <el-checkbox-group v-model="excludeLabelChecks" class="f_checks_box" v-if="showMore3">
                    <el-checkbox :label="item.LabelId" v-for="(item,index) in excludeLabelList" :key="index" v-show="showMore3 ? index < 10 : index + 1">
                      <span>{{item.LableName}}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- <div class="r_more_txt" v-if="excludeLabelList.length > 0" @click="excludeHandle">
                    <span>更多</span>
                    <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore3 }"></i>
                  </div> -->
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="drop-footer">
            <el-button size="small" plain @click="resetHandle()">清空</el-button>
            <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
            <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
        </div>
      </div>
    <!-- </el-collapse-transition> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>人才库</el-breadcrumb-item>
          <el-breadcrumb-item>个人资源</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs" v-if="checkPermission(['personalResources_page_list'],permissionLists)">
        <!-- <ResourceComTabs ref="child"></ResourceComTabs> -->
        <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
          <el-tab-pane :disabled="tableLoading" label="个人资源" name="个人资源"></el-tab-pane>
          <el-tab-pane :disabled="tableLoading" label="公海资源" name="公海资源"></el-tab-pane>
        </el-tabs> -->
        <div class="r_act_box">
          <div class="r_act_left">
            <!-- <div class="r_act_item">
              <el-button size="small" plain @click="noticeHandle">通知</el-button>
            </div> -->
            <div class="r_act_item" v-if="checkPermission(['personalResources_surface'],permissionLists)">
              <el-button size="small" type="primary" @click="surDialogHandle">约面</el-button>
            </div>
            <div class="r_act_item" v-if="checkPermission(['personalResources_enter'],permissionLists)">
              <el-button size="small" type="primary" @click="enterHandle">录入</el-button>
            </div>
            <div class="r_act_item" v-if="checkPermission(['personalResources_throw_public'],permissionLists)">
              <el-button size="small" type="primary" @click="launchAllHandle">投放公海</el-button>
            </div>
            <div class="r_act_item" v-if="checkPermission(['personalResources_divide'],permissionLists)">
              <el-button size="small" type="primary" @click="divideHandle">分配</el-button>
            </div>
            <div class="r_act_item" v-if="isQwHandle&&(checkPermission(['personalResources_sync'],permissionLists))">
              <el-button size="small" class="com_btn" @click="syncHandle">企微好友同步</el-button>
            </div>
            <div class="r_act_item" v-if="checkPermission(['personalResources_import'],permissionLists)">
              <el-button size="small" class="com_btn" @click="importHandle">简历导入</el-button>
            </div>
            <div class="r_act_item" v-if="this.tableData.length > 0&&(checkPermission(['personalResources_export'],permissionLists))">
              <el-button size="small" class="com_btn" @click="exportHandle" :loading="btnLoading">简历导出</el-button>
            </div>
          </div>
          <div class="r_act_right">
            <p class="r_txt01">自助填写简历:</p>
            <el-popover placement="bottom" width="200" trigger="click" class="img_popover">
              <div class="qrcode_box">
                  <img :src="canvasImg" class="qrcode_img02" />
                  <!-- <p class="r_txt03">cccc</p> -->
                  <!-- <a :href="canvasImg" download="企业码" target="_blank">点击下载</a> -->
              </div>
              <el-button slot="reference" class="qcode_btn" type="text">
                  <img src="./../../assets/images/qrcode.png"
                  class="qrcode_img01"
                  @click="cerateQCode"
                  />
              </el-button>
            </el-popover>
            <!-- <span class="r_txt02" @click="repeatHandle">链接复制分享</span> -->
          </div>
        </div>
        <el-table ref="multipleTable" class="re_table" v-loading="tableLoading" :highlight-current-row="true" @selection-change="handleSelectionChange" :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <el-table-column type="selection" width="55" align="center" v-if="switchBtn" label-class-name="com_Selection"></el-table-column>
          <template v-for="(item,index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('性别')>-1||item.StrColumName.indexOf('年龄')>-1||item.StrColumName.indexOf('籍贯')>-1||item.StrColumName.indexOf('学历')>-1 ? '50px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('地')>-1||item.StrColumName.indexOf('时间')>-1?'150px':'110px'" align="center"
              :fixed="item.StrColumName=='姓名'">
              <template slot-scope="{row}">
                <span>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column align="center" label="操作" fixed="right" width="240px" class-name="re_act_box">
            <template slot-scope="{row}">
              <el-button v-if="checkPermission(['personalResources_follow'],permissionLists)" type="info" size="mini" plain @click="followHandle(row)">跟进</el-button>
              <el-button v-if="checkPermission(['personalResources_label'],permissionLists)" type="info" size="mini" plain @click="labelHandle(row)">标签</el-button>
              <el-button v-if="checkPermission(['personalResources_dtl'],permissionLists)" type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
              <el-button v-if="checkPermission(['personalResources_enter'],permissionLists)" type="info" size="mini" plain @click="launchHandle(row)">投放公海</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100, 200]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
    <!-- 分配记录 -->
    <el-dialog title="分配记录" :visible.sync="divRecordVisible" width="760px" class="res_dialog divide_dialog">
      <el-table v-loading="recLoading" :data="recTableData" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
                <span>{{(Number(listRecordQuery.currpage) - 1) * Number(listRecordQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="时间" min-width="110px">
            <template slot-scope="{row}">
                <span>{{row.DtDistDate}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="内容">
            <template slot-scope="{row}">
                <span>{{row.GddistUsername}}分配{{row.ResumeIdcount}}条简历至{{row.BelongUsername}}</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="recCurrentChange"
            :current-page.sync="listRecordQuery.currpage"
            :page-size="listRecordQuery.perpage"
            @size-change="recSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="rectotal"
          ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button
            type="success"
            @click="divRecordVisible = false"
            size="small"
            >关闭</el-button>
      </span>
    </el-dialog>
    <!-- 录入简历弹框 -->
    <el-dialog title="录入简历" :visible.sync="enterResumeVisible" width="800px" class="res_dialog enter_dialog">
      <p v-if="enterNoteTxt" style="font-size:14px;color:red;margin-bottom:10px;text-align: right;">该简历已被录入</p>
      <el-form :inline="true" :rules="enterRules" ref="enterResumeForm" :model="enterResumeQuery" class="re_down_form" label-width="100px">
        <el-form-item label="姓名:" prop="StrUserName">
            <el-input v-model="enterResumeQuery.StrUserName" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系方式:" prop="StrMobile">
            <el-input v-model="enterResumeQuery.StrMobile" size="small" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="BolUserSex">
          <el-select v-model="enterResumeQuery.BolUserSex" size="small">
            <el-option label="女" value="女"></el-option>
            <el-option label="男" value="男"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄:" prop="StrUserAge">
            <el-input v-model="enterResumeQuery.StrUserAge" size="small" type="number" min="1" oninput="value=value.replace(/\D+/g,'')" clearable></el-input>
        </el-form-item>
        <el-form-item label="意向地区:" prop="StrUserCity">
          <el-cascader :props="propsAddress" ref="cascaderArr" filterable size="small" v-model="strCityCode" :options="provinces" @change="changeArea"></el-cascader>
        </el-form-item>
        <el-form-item label="意向岗位:" prop="posCategoryList">
          <el-cascader ref="poSectionArr" size="small"
            v-model="enterResumeQuery.posCategoryList" :props="propPosition" clearable
            :options="intendedPost"
            @change="poSectionChange"></el-cascader>
        </el-form-item>
        <el-form-item label="期望薪资:">
          <div class="r_line_box">
            <el-input v-model="enterResumeQuery.salary1" size="small" type="number" min="0" oninput="value=value.replace(/\D+/g,'')" clearable class="r_line_input1"></el-input>
            <span class="r_line_txt"></span>
            <el-input v-model="enterResumeQuery.salary2" size="small" type="number" min="0" oninput="value=value.replace(/\D+/g,'')" clearable class="r_line_input2"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="简历来源:" prop="StrSource">
          <el-select v-model="enterResumeQuery.StrSource" placeholder="" size="small" >
            <el-option v-for="item in originList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <div class="f_all_width">
          <p class="r_l_title">公有标签</p>
          <div class="r_more_box">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="(item, j) in publicList" :key="item.LbGroup.Id" v-show="showMore4 ? j < 1 : j + 1">
                <div class="dia_groupname">{{item.LbGroup.LableName+':'}}</div>
                <el-checkbox-group v-model="includePublicChecks" @change="lPubEnterHandle">
                  <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="r_more_txt" style="margin-top:10px;" v-if="!isNull(publicList)&&publicList.length > 1" @click="showMore4 = !showMore4">
              <span>{{showMore4 ? '更多':'收起'}}</span>
              <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore4 }"></i>
            </div>
          </div>
          <!-- <p class="r_l_title" v-if="privateList">私有标签</p>
          <div class="r_more_box">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="(item, i) in privateList" :key="item.LbGroup.Id" v-show="showMore6 ? i < 1 : i + 1">
                <div class="dia_groupname">{{item.LbGroup.LableName+':'}}</div>
                <el-checkbox-group v-model="includePrivateChecks" @change="lPraEnterHandle">
                  <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="r_more_txt" style="margin-top:10px;" v-if="!isNull(privateList)&&privateList.length > 1" @click="showMore6 = !showMore6">
                <span>{{showMore6 ? '更多':'收起'}}</span>
                <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore6 }"></i>
              </div>
          </div> -->
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="enterResumeVisible = false"
            size="small"
            >取消</el-button
          >
          <el-button
            type="primary" class="com_dialog_btn"
            @click="saveEnterHandle"
            size="small"
            >保存</el-button>
      </span>
    </el-dialog>
    <!-- 选择简历分配对象弹框 -->
    <el-dialog title="选择简历分配对象" :visible.sync="divideVisible" width="760px" class="res_dialog divide_dialog">
      <div class="res_dialog_popover">
        <el-button slot="reference" class="d_btn" type="success" plain size="mini" @click="divideDtlHandle">分配记录</el-button>
      </div>
      <div class="d_rule_box">
        <p class="txt01">简历分配规则:</p>
        <p class="txt02">1、简历分配为复制机制且共享编辑，维护的信息会同步所有人。</p>
        <p class="txt02">2、同一份简历最多分给5个部门，每个部门最多5份简历。</p>
        <p class="txt02">3、如分配超出数量限制，则会按顺序机制分配至选中的部分人员，下次配合优先未分配到的人员。</p>
        <p class="txt02">4、多份简历分配多人时同样遵循以上规则。</p>
      </div>
      <p v-if="isCheckDepart" class="d_rule_txt01">最多能分配给五个部门,每个部门最多5份简历。</p>
      <el-form :rules="divideRules" ref="divideForm" :model="divideQuery" class="re_dialog_form re_dialog_form02" label-width="140px">
        <el-form-item label="分配给部门/人员:" prop="perDepartList">
            <el-cascader size="small" ref="departLabel" popper-class="disableFirstLevel"
            v-model="divideQuery.perDepartList" :props="props" clearable filterable
            :options="departList" placeholder="请选择部门或人员"
            @change="perSectionChange"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="divideVisible = false"
            size="small"
            >取消</el-button>
          <el-button :loading="divLoading"
            type="primary" class="com_dialog_btn"
            @click="saveDivideHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
    <!-- 消息沟通弹框 -->
    <el-dialog title="消息沟通" :visible.sync="noticeVisible" width="850px" class="res_dialog">
      <div class="notice_title">
        <span @click="jumpSendRecord">查询发送记录</span>
        <i class="el-icon-d-arrow-right"></i>
      </div>
      <el-form :rules="noticeRules" ref="noticeForm" :model="noticeQuery" class="re_dialog_form" label-width="130px">
        <el-form-item label="选择通知方式:" prop="checkNoticeList">
            <el-checkbox-group v-model="checkNoticeList">
            <!-- <el-checkbox label="微信"></el-checkbox> -->
            <el-checkbox label="短信"></el-checkbox>
            <!-- <el-checkbox label="企微好友"></el-checkbox> -->
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="选择通知模板:" prop="module">
          <el-select size="small"
            v-model="noticeQuery.TemplateId" filterable clearable
            placeholder="请选择模板" @change="tempHandle"
          >
              <el-option
                  v-for="(item, index) in noticeTempList"
                  :key="index"
                  :label="item.TemplateName"
                  :value="item.Id">
              </el-option>
          </el-select>
        </el-form-item>
        <!-- <div v-for="index in inputNum" :key="index">
            <el-form-item :label="'参数'+(index)+':'">
                <el-input v-model="inputList[index]" size="small" clearable/>
            </el-form-item>
        </div> -->
        <el-form-item label="模板信息:">
          <el-input
            type="textarea"
            :rows="2"
            v-model="moduleInfo">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="noticeVisible = false"
            size="small"
            >取消</el-button>
          <el-button
            type="primary" class="com_dialog_btn"
            @click="saveNoticeHandle"
            size="small"
            >提交</el-button>
      </span>
      <el-table v-loading="noticeLoading" :highlight-current-row="false" :data="noticeData" style="width:100%">
        <template v-for="(item,index) in tableNoteTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :key="index" :min-width="item.StrColumName=='姓名'?'80px':item.StrColumName=='地址'?'160px':'100px'" align="center"
             >
              <template slot-scope="{row}">
                <div v-if="item.dynamic == '0'">{{row[item.StrColumId]}}</div>
                <div v-if="item.dynamic == '1'">
                  <el-input v-model="row[item.StrColumId]" size="small" clearable/>
                </div>
              </template>
            </el-table-column>
          </template>
      </el-table>
    </el-dialog>
    <!-- 标签弹框 -->
    <el-dialog title="标签" :visible.sync="labelVisible" width="600px" class="res_dialog">
      <div class="e_txt_box">
        <el-button type="text" @click="addLabelHandle">打标签</el-button>
      </div>
      <el-form ref="noticeForm" class="re_dialog_form" label-width="80px">
        <el-form-item label="" v-if="!isNull(lPubDialogList)">
          <span v-for="(item,index) in lPubDialogList" :key="index">{{item.LableName+';'}}</span>
        </el-form-item>
        <!-- <el-form-item label="私有标签:" v-if="!isNull(lPriDialogList)">
          <span v-for="(item,index) in lPriDialogList" :key="index">{{item.LableName+';'}}</span>
        </el-form-item>
        <el-form-item label="私有标签:" v-if="isNull(lPriDialogList)">
          <span>暂无数据</span>
        </el-form-item> -->
      </el-form>
      <div class="com_empty" v-if="isNull(lPubDialogList)">
        <p>暂无数据</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="com_dialog_btn"
            @click="labelVisible = false"
            size="small"
            >关闭</el-button>
      </span>
    </el-dialog>
    <!-- 添加标签弹框 -->
    <el-dialog title="编辑标签" :visible.sync="addlabelVisible" width="700px" class="res_dialog">
      <div class="r_label_box" v-loading="laloading">
        <el-tabs v-model="labelActiveName" @tab-click="handleLabelClick">
          <el-tab-pane label="全局标签" name="全局标签">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="item in publicList" :key="item.LbGroup.Id">
                <div class="dia_groupname">{{item.LbGroup.LableName}}</div>
                <el-checkbox-group v-model="wholeCheckList" @change="dPubEnterHandle">
                  <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="私有标签" name="私有标签">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="item in privateList" :key="item.LbGroup.Id">
                <div class="dia_groupname">{{item.LbGroup.LableName}}</div>
                <el-checkbox-group v-model="wholeCheckList2" @change="dPraEnterHandle">
                  <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
        @click="addlabelVisible = false"
        size="small"
        >取消</el-button>
        <el-button type="primary" class="com_dialog_btn"
        @click="saveLabelHandle"
        size="small"
        >保存</el-button>
      </span>
    </el-dialog>
    <!-- 跟进弹框 -->
    <el-dialog title="跟进" :visible.sync="followVisible" width="800px" class="res_dialog">
      <el-tabs v-model="activeFollowName" @tab-click="followHandleClick">
        <el-tab-pane label="人岗匹配推荐" name="人岗匹配推荐"></el-tab-pane>
        <el-tab-pane label="跟进记录" name="跟进记录"></el-tab-pane>
        <el-tab-pane label="流程记录" name="流程记录"></el-tab-pane>
      </el-tabs>
      <div class="f_list_box" v-if="activeFollowName == '人岗匹配推荐'">
          <el-table v-loading="recommendLoading" :data="recommendList" class="re_table" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
                <span>{{(Number(matchQuery.pageNum) - 1) * Number(matchQuery.pageSize) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目" min-width="90px">
            <template slot-scope="{row}">
                <span>{{row.StrprojectName}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="90px">
            <template slot-scope="{row}">
                <span>{{row.CustomerJobName}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="综合薪资" min-width="90px">
            <template slot-scope="{row}">
                <span v-if="!isNull(row.rpj.ComprehensiveSalary)">
                  {{row.rpj.ComprehensiveSalary}}
                  <span v-if="!isNull(row.rpj.ComprehensiveSalaryEnd)">{{'~ '+row.rpj.ComprehensiveSalaryEnd}}</span>
                </span>
              </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="上班地点" min-width="180px">
            <template slot-scope="{row}">
                <span>{{row.rpj.InterviewProvinceName+row.rpj.InterviewCityName+row.rpj.InterviewAraeName+row.rpj.InterviewAddress}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="最新缺口" min-width="90px">
            <template slot-scope="{row}">
                <span>{{row.StrgapNum}}</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
              @current-change="recommendCurrentChange"
              :current-page.sync="matchQuery.pageNum"
              :page-size="matchQuery.pageSize"
              @size-change="recommendSizeChange"
              :page-sizes="[10, 20, 50, 100]"
              layout="total,prev,pager,next,jumper"
              :total="matchCount"
          ></el-pagination>
        </div>
          <!-- <div class="f_table" v-if="!isNull(recommendList)">
          <div class="f_list_item" v-for="(item,index) in recommendList" :key="index" v-show="showMore5 ? index < 6 : index + 1">
            <span>{{(index+1)+'.'}}</span>
            <span>{{item.rpj.StrprojectName}}</span>
            <span>{{!isNull(item.rpj.JobCategory)?item.rpj.JobCategory:''}}</span>
            <span>{{!isNull(item.rpj.ComprehensiveSalary)?item.rpj.ComprehensiveSalary:''}}</span>
            <span>{{!isNull(item.rpj.WorkingShift)?item.rpj.WorkingShift:''}}</span>
            <span>{{item.rpj.InterviewProvinceName+item.rpj.InterviewCityName+item.rpj.InterviewAraeName}}</span>
            <span>{{!isNull(item.rpj.InterviewAddress)?item.rpj.InterviewAddress:''}}</span>
          </div>
          <div class="r_more_txt" v-if="matchCount > 6" @click="showMore5 = !showMore5">
            <span>{{showMore5 ? '更多':'收起'}}</span>
            <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore5 }"></i>
          </div>
        </div>
        <div v-else style="width:100%;padding:20px 0;color:#999;font-size:15px;text-align:center;">暂无数据</div> -->
      </div>
      <div class="f_list_box" v-if="activeFollowName == '跟进记录'">
        <el-form :rules="followRules" ref="followForm" :model="recommendQuery" class="re_follow_form" label-width="130px">
          <el-form-item label="更新求职意向:" prop="StrUserJobhunt">
            <el-radio-group v-model="recommendQuery.StrUserJobhunt">
              <el-radio label="有工作考虑新机会"></el-radio>
              <el-radio label="在找工作"></el-radio>
              <el-radio label="不找工作"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="选择未约面原因:" prop="StrReason">
            <el-input v-model="recommendQuery.StrReason" size="small" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="跟进内容:" prop="StrRemark">
            <el-input v-model="recommendQuery.StrRemark" type="textarea" rows="3" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="f_btns" v-if="activeFollowName == '跟进记录'">
          <el-button
              @click="followVisible = false"
              size="small"
              >关闭</el-button
            >
            <el-button
              type="primary" class="com_dialog_btn"
              @click="saveFollowHandle"
              size="small"
              >保存</el-button>
        </div>
        <el-table v-loading="followLoading" :highlight-current-row="false" class="re_table" :data="followData" style="width:100%;max-height:200px;overflow-y:auto;">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
                <span>{{(Number(followQuery.currpage) - 1) * Number(followQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="求职意愿" min-width="110px">
            <template slot-scope="{row}">
                <span>{{row.StrUserJobhunt}}</span>
              </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="未约面原因">
            <template slot-scope="{row}">
                <span>{{row.StrReason}}</span>
              </template>
          </el-table-column> -->
          <el-table-column align="center" label="跟进内容">
            <template slot-scope="{row}">
                <span>{{row.StrRemark}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="发言人">
            <template slot-scope="{row}">
                <span>{{row.userName}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="时间" min-width="110px">
            <template slot-scope="{row}">
                <span>{{isNull(row.DtInserDate)?'':row.DtInserDate.replace('T',' ')}}</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange1"
                :current-page.sync="followQuery.currpage"
                :page-size="followQuery.perpage"
                @size-change="handleSizeChange1"
                :page-sizes="[10, 20, 50, 100]"
                layout="total,prev,pager,next,jumper"
                :total="totalFollow"
            ></el-pagination>
        </div>
      </div>
      <div class="f_list_box" v-if="activeFollowName == '流程记录'">
        <el-table v-loading="serviceLoading" :highlight-current-row="false" class="re_table" :data="serviceData" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
                <span>{{(Number(serviceQuery.currpage) - 1) * Number(serviceQuery.perpage) + Number($index) + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrprojectName}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="岗位名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.JobCategory}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="流程名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrState}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="流程时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span v-if="row.StrState == '已报名'">{{isNull(row.DtInserDate)?'':row.DtInserDate.replace('T',' ')}}</span>
              <span v-if="row.StrState == '约面'">{{isNull(row.Dtappotime)?'':row.Dtappotime.replace('T',' ')}}</span>
              <span v-if="row.StrState == '入职'">{{isNull(row.DtInducttime)?'':row.DtInducttime.replace('T',' ')}}</span>
              <span v-if="row.StrState == '离职'">{{isNull(row.Dtquittime)?'':row.Dtquittime.replace('T',' ')}}</span>
              <span v-if="row.StrState == '通过'">{{isNull(row.Dtreachtime)?row.Dtadopttime:row.Dtreachtime}}</span>
              <span v-if="row.StrState == '到面'">{{isNull(row.Dtfacetime)?'':row.Dtfacetime.replace('T',' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作人员" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.Username}}</span>
              </template>
          </el-table-column>
          <el-table-column align="center" label="操作时间" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{isNull(row.DtInserDate)?'':row.DtInserDate.replace('T',' ')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程备注" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span>{{row.StrRemark}}</span>
              </template>
          </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange2"
                :current-page.sync="serviceQuery.currpage"
                :page-size="serviceQuery.perpage"
                @size-change="handleSizeChange2"
                :page-sizes="[10, 20, 50, 100]"
                layout="total,prev,pager,next,jumper"
                :total="totalService"
            ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 简历导入弹框 -->
    <el-dialog title="简历导入" :visible.sync="importVisible" width="700px" class="res_dialog">
      <ImportItem :typeName="typeName" @changeDialog="fatherChange"></ImportItem>
      <span slot="footer" class="dialog-footer" v-if="curractive == 2">
        <el-button type="primary" class="com_dialog_btn" size="small" @click="backHandle">确定并返回</el-button>
        <el-button size="small" @click="resultHandle">查看导入结果</el-button>
      </span>
    </el-dialog>
    <!-- 搜索包含标签弹框 -->
    <el-dialog title="选择标签" :visible.sync="includeSearchVisible" width="800px" class="res_dialog">
      <el-tabs v-model="activeLabelName">
        <el-tab-pane label="全局标签" name="全局标签">
          <div class="dia_label_box">
            <div class="dia_label_item" v-for="item in publicList" :key="item.LbGroup.Id">
              <div class="dia_groupname" v-if="!isNull(item.LbGroupVallist)">{{item.LbGroup.LableName}}</div>
              <el-checkbox-group v-model="includeCheckList01">
                <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index" v-show="!isNull(item.LbGroupVallist)">
                  <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="私有标签" name="私有标签">
          <div class="dia_label_box">
            <div class="dia_label_item" v-for="item in privateList" :key="item.LbGroup.Id">
              <div class="dia_groupname" v-if="!isNull(item.LbGroupVallist)">{{item.LbGroup.LableName}}</div>
                <el-checkbox-group v-model="includeCheckList02">
                  <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index" v-show="!isNull(item.LbGroupVallist)">
                    <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                  </el-checkbox>
                </el-checkbox-group>
            </div>
          </div>
        </el-tab-pane> -->
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button
            @click="includeSearchVisible = false"
            size="small"
            >取消</el-button> -->
        <el-button type="primary" class="com_dialog_btn"
            @click="inSearchHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
    <!-- 搜索排除标签弹框 -->
    <el-dialog title="选择标签" :visible.sync="encludeSearchVisible" width="800px" class="res_dialog">
      <el-tabs v-model="activeLabelName01">
        <el-tab-pane label="全局标签" name="全局标签">
          <div class="dia_label_box">
            <div class="dia_label_item" v-for="item in publicList" :key="item.LbGroup.Id">
              <div class="dia_groupname" v-if="!isNull(item.LbGroupVallist)">{{item.LbGroup.LableName}}</div>
              <el-checkbox-group v-model="encludeCheckList01">
                <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index" v-show="!isNull(item.LbGroupVallist)">
                  <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="私有标签" name="私有标签">
          <div class="dia_label_box">
            <div class="dia_label_item" v-for="item in privateList" :key="item.LbGroup.Id">
              <div class="dia_groupname" v-if="!isNull(item.LbGroupVallist)">{{item.LbGroup.LableName}}</div>
                <el-checkbox-group v-model="encludeCheckList02">
                  <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index" v-show="!isNull(item.LbGroupVallist)">
                    <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                  </el-checkbox>
                </el-checkbox-group>
            </div>
          </div>
        </el-tab-pane> -->
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="com_dialog_btn"
            @click="enSearchHandle"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
    <!-- 约面弹框 -->
    <el-dialog title="约面" :visible.sync="surfaceVisible" width="760px" class="sur_dialog">
      <el-table v-loading="surfaceLoading" :data="surfaceTableData" style="width:100%">
        <el-table-column align="center" label="*项目" min-width="160px">
          <template slot-scope="{row}">
            <el-select v-model="row.Projectid" filterable clearable
              size="mini" placeholder="" @change="surProChange(row)"
            >
            <el-option
              v-for="(item, index) in resProjectList"
              :key="index"
              :label="item.StrprojectName"
              :value="item.Projectid">
            </el-option>
          </el-select>
            </template>
        </el-table-column>
        <el-table-column align="center" label="*岗位" min-width="140px">
          <template slot-scope="{row}">
            <el-select v-model="row.Jobid" filterable clearable
              size="mini" placeholder="" @change="surPostChange(row)"
            >
            <el-option
              v-for="(item, index) in row.resPostList"
              :key="index"
              :label="item.JobCategory"
              :value="item.Id">
            </el-option>
          </el-select>
            </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="缺口提醒" min-width="80px">
          <template slot-scope="{row}">
              <span style="color:#F56C6C;">{{row.StrNeedAmount}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="90px">
          <template slot-scope="{row}">
              <span>{{row.StrUserName}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="手机号" min-width="110px">
          <template slot-scope="{row}">
              <span>{{row.StrMobile}}</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="黑名单标签" fit :show-overflow-tooltip="true" width="130px">
          <template slot-scope="{row}">
            <span class="b_txt_com" v-if="!isNull(row.StrBlackReason)">{{row.StrBlackReason}}</span>
            <span v-if="isNull(row.StrBlackReason)">无</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*面试日期" min-width="125px">
          <template slot-scope="{row}">
            <el-select v-model="row.appDtviewDate" filterable clearable
              size="mini" placeholder="" @change="diaSurdateChange(row)">
              <el-option v-for="(item, index) in row.viewDateList" :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            </template>
        </el-table-column>
        <el-table-column align="center" label="*面试时间" min-width="125px">
          <template slot-scope="{row}">
            <el-select v-model="row.appDtviewTime" filterable clearable
              size="mini" placeholder=""
            >
              <el-option
                v-for="(item, index) in row.viewTimesList"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            </template>
        </el-table-column>
        <el-table-column align="center" label="住宿需求" width="112px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrAccomreq" placeholder="" size="small" clearable>
              <el-option label="需要" value="需要"></el-option>
              <el-option label="不需要" value="不需要"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="备注" min-width="150px">
          <template slot-scope="{row}">
              <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
            </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="提醒" min-width="110px">
          <template slot-scope="{row}">
              <span>{{row.Strremind}}</span>
            </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="surfaceVisible = false" size="small">取消</el-button>
        <el-button type="success" :loading="faceLoading" size="small" class="com_dialog_btn" @click="saveSurfaceHandle">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import xz from "./../../common";
import FUN from "./../../fun";
import moment from 'moment'
import checkPermission from '@/utils/permission' // 权限判断函数
import ImportItem from "./components/importItem.vue"
import ResourceComTabs from "./components/resourceComTabs.vue"
export default {
  components: {
    ImportItem,
    ResourceComTabs
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      // const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[6]|18[0-9]|19[6,9]|17[0-9])\d{8}$/i;
      const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
      // console.log('validatePhone',value)
      if (value.length == 11 && phoneReg.test(value)) {
        //校验通过
        if(this.enterBtnType != 'save'){
          this.checkHandle(value, (res) => {
            // console.log('validatePhone',res)
            if (res) {
              this.getResumeDtl(this.enterResumeQuery.ResumeId)
              callback()
            } else {
              this.enterNoteTxt = false
              // this.enterResumeQuery = this.$options.data().enterResumeQuery
              // this.enterResumeQuery.StrMobile = value
              // this.includePublicChecks = []
              // this.includePrivateChecks = []
              callback()
            }
          })
        }else{
          callback()
        }
      } else {
        callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      enterBtnType:'',
      divLoading:false,
      // 是否有企微同步权限
      isQwHandle: false,
      // 登录id
      loginid: Cookies.get("userid-b"),
      surfaceLoading:false,
      surfaceVisible:false,
      surfaceTableData:[],
      activeLabelName:'全局标签',
      activeLabelName01:'全局标签',
      includeSearchVisible:false,
      encludeSearchVisible:false,
      // 超过五个部门提示
      isCheckDepart:false,
      // 录入提示
      enterNoteTxt:false,
      // 标签搜索
      includeCheckList01:[],
      includeCheckList02:[],
      encludeCheckList01:[],
      encludeCheckList02:[],
      typeName:'个人资源简历',
      // 是否获取过全部标签(包含标签)
      isGetALLLabel1:true,
      // 是否获取过全部标签(排除标签)
      isGetALLLabel2:true,
      // 模板信息
      moduleInfo:'',
      // 导入显示页面
      curractive: 0,
      // 选中的地区code
      strCityCode: [],
      // 表头
      tableTitle: [],
      // 表头参数
      titleQuery: {
        strTableId: 'JB_busi_PsnBase',
        strIsFixed: '' // 1 基础 0 扩展 空 所有
      },
      // 意向岗位列表
      intendedPost: [],
      // 所有标签
      allLabelList: [],
      // 录入简历公有标签
      includePublicChecks: [],
      // 录入简历私有标签
      includePrivateChecks: [],
      // 上传模板
      ExcelSrc: {
        value: '',
        check: false,
        fileName: ''
      },
      //错误提醒
      errorTxt:'',
      //导入excel路径
      excelpath:'',
      // 弹框
      importVisible: false,
      enterResumeVisible: false,
      divideVisible: false,
      // 录入简历参数
      enterResumeQuery:{
        ResumeId: '0', //简历ID
        StrUserName: '', //姓名
        StrMobile: '', //联系方式
        StrWorkState: '', //当前状态
        BolUserSex: '', //性别
        StrUserAge: '', //年龄
        StrNativePlace: '', //户籍
        StrEduLvl: '', //学历
        StrJobInf: '', //意向岗位
        StrCategoryIds: '', //意向岗位id
        // 选中的意向岗位
        posCategoryList: [],
        StrUserCity: '', //求职城市
        StrUserAdd: '', //居住地
        StrUserCityCode: '', //求职城市code
        StrSource: '', //来源
        StrUserExpectSa: '', //期望薪资
        salary1: '',
        salary2: '',
        StrRemark: '', //备注
        StrlateCompany: '', //最近入职项目
        DtlateInducDate: '', //最近入职时间
        DtlatequitDate: '', //最近离职时间
        StrquitReason: '', //离职原因
        StrUserJobhunt: '', //求职意向
        StrPsnIsType: '', //是否公海 1 公海 0私人
        StrJobType:'', //岗位类型
        StrState:'', //在离职状态
        //拓展
        StrIsBlack: '', //是否黑名单
        StrBlackReason: '', //黑名单原因
        StrUsernation: '', //民族
        Strskill: '', //技能
        Strcertificate: '', //证书
        StrAccomreq: '', //住宿要求
        StrDinreq: '', //吃饭要求
        StrIsqwfri: '', //是否企微好友
        StrCont1: '', //拓展1
        StrCont2: '',
        StrCont3: '',
        StrCont4: '',
        StrCont5: '',
        StrCont6: '',
        StrCont7: '',
        StrCont8: '',
        StrCont9: '',
        StrCont10: '',
        WorkingShift: '', // 班次
        Workingposition: '', // 站班/坐班
        StrResumefile: '',// 简历附件名称
        StrResumefileUrl: '' // 简历附件路径
      },
      // 分配简历参数
      divideQuery:{
        resumeIds:'', // 简历id (多条用,连接)
        userIds:'', // 人员id (多条用,连接)
        StrPsnIsType:'0', // 0 私有  1公海
        perDepartList:[]
      },
      // 分配选中的人员
      dividePersonList: [],
      // 简历来源
      originList:[],
      // 录入简历规则
      enterRules: {
        StrUserName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        StrMobile: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur'] }
        ],
        StrUserCity: [
          { required: true, message: '请选择意向地区', trigger: 'change' }
        ],
        BolUserSex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        StrSource: [
          { required: true, message: '请选择简历来源', trigger: 'change' }
        ],
        posCategoryList: [
          { type: 'array', required: true, message: '请选择意向岗位', trigger: 'change'}
        ],
        StrUserAge: [
          { required: true, message: '请输入年龄', trigger: 'blur' }
        ]
      },
      // 分配简历对象
      divideRules: {
        perDepartList: [
          { type: 'array', required: true, message: '请选择部门或人员', trigger: 'change'}
        ]
      },
      // 通知
      noticeRules: {
        TemplateId: [
          { required: true, message: '请选择通知模板', trigger: 'change' }
        ],
        checkNoticeList: [
          { type: 'array', required: true, message: '请选择通知方式', trigger: 'change'}
        ]
      },
      // 人岗匹配推荐
      followRules: {
        StrUserJobhunt: [
          { required: true, message: '请选择求职意愿', trigger: 'change' }
        ]
      },
      // 人岗匹配推荐
      recommendQuery:{
        ResumeId:'', // 简历id
        StrUserJobhunt:'', // 求职意愿
        StrReason:'', // 原因
        StrRemark:'', // 备注
        GduserId:'', // 操作人
        GduserName:'', // 操作人姓名
        StrOther:'', // 其他
        fCheckList: []
      },
      // 部门参数
      departQuery:{
        strorgancode:'',
        roletype:''
      },
      departMemberQuery: {
        currpage: 1,
        perpage: 10000000,
        keyword: "",
        strWorkState: "在职",
        strstation: "",
        strorgancode: ""
      },
      // 部门列表
      departList:[],
      // 人员列表
      memberList:[],
      // 自定义 级联选择props
      propPosition: { label: 'strParametername', value: 'strParameterid', children: 'children', checkStrictly: true },
      props: { label: 'strorganname', value: 'strorgancode', children: 'children', multiple: true },
      tableHeight: 0,
      showDropScreen: -1,
      activeName: '个人资源',
      tabids: [],
      // 列表参数
      listQuery:{
        strUserName: '', // 姓名
        strMobile: '', // 联系方式
        bolUserSex: '', // 性别
        strUserAdd: '', // 居住地
        strJobInf: '', // 意向岗位
        strUserAgeb: '', // 年龄开始
        strUserAgee: '', // 年龄结束
        strUserExpectSab: '', // 薪资
        strUserExpectSae: '', // 薪资
        strpsnJob: '', // 人岗匹配岗位
        strWorkState: '', // 状态
        strlabelbh: '', // 包含标签
        strlabelpc: '', // 排除标签
        strUserCity:'', // 意向地区
        strCityCode:'', // 意向地区码
        strUserJobhunt:'', // 求职意向
        currpage: 1, // 分页
        perpage: 10,
        posCategoryList:[],//意向岗位
        jobList:[]// 人岗匹配岗位
      },
      // 导出参数
      exportQuery:{
        stroutid:'', //勾选的id
        strUserName: '', // 姓名
        strMobile: '', // 联系方式
        bolUserSex: '', // 性别
        strUserAdd: '', // 居住地
        strJobInf: '', // 意向岗位
        strUserAgeb: '', // 年龄开始
        strUserAgee: '', // 年龄结束
        strUserExpectSab: '', // 薪资
        strUserExpectSae: '', // 薪资
        strpsnJob: '', // 人岗匹配岗位
        strWorkState: '', // 状态
        strlabelbh: '', // 包含标签
        strlabelpc: '', // 排除标签
        strUserCity:'', // 意向地区
        strCityCode:'', // 意向地区码
        strUserJobhunt:'', // 求职意向
        currpage: 1, // 分页
        perpage: 1000000
      },
      // 人岗匹配岗位列表
      postList:[],
      // 当前状态列表
      statusList:[],
      // 已选中的状态
      statusCheckList:[],
      // 已选中的包含标签
      includeLabelChecks:[],
      // 已选中的排除标签
      excludeLabelChecks:[],
      // 包含标签
      includeLabelList:[],
      // 排除标签
      excludeLabelList:[],
      //显示更多
      showMore1: true,
      showMore2: true,
      showMore3: true,
      showMore4: true,
      showMore5: true,
      showMore6: true,
      switchBtn: true,
      canvasImg: './../../../assets/images/qrcode.png',
      tableLoading: false,
      tableData: [],
      isCanHandle: true,
      total: 0,
      multipleSelection: [],
      divideLoading: false,
      noticeVisible: false,
      noticeLoading: false,
      labelVisible: false,
      addlabelVisible: false,
      laloading: false,
      followVisible: false,
      // 分配记录列表
      divideData:[],
      // 消息通知参数
      noticeQuery:{
        TemplateId: '', 
        SendList:[]
      },
      checkNoticeList: ['短信'],
      imgPath: this.$store.state.EMP.imgPath,
      // 通知模板
      noticeTempList: [],
      // 消息通知列表数据
      noticeData: [],
      // 标签列表
      wholeCheckList: [],
      wholeCheckList2: [],
      // 全局标签列表
      publicList: [],
      // 私有标签列表
      privateList: [],
      roleType: localStorage.loginRoletype,
      labelActiveName: '全局标签',
      activeFollowName: '人岗匹配推荐',
      // 人岗匹配推荐列表
      recommendList: [],
      // 投入公海参数
      injectQuery:{
        resumeIds: '' // 简历id (多条用,连接)
      },
      // 服务记录
      serviceLoading: false,
      serviceData: [],
      // 跟进记录
      followLoading: false,
      followData: [],
      // 简历录入打标签参数
      enterTagQuery: {
        resumeIds: '', // 简历id (多条用,连接)
        labelIds: '' // 标签id (多条用,连接)
      },
      // 简历录入已经打的标签
      enTagChecks:[],
      // 省份
      provinces: [],
      propsAddress: {
        // lazy: true,
        checkStrictly: true,
        value: 'Id',
        label: 'Name',
        children: 'children'
        // lazyLoad(node, resolve) {
        //   const { value, level } = node;
        //   if (value && value != undefined) {
        //     xz.getArea(value).then(res => {
        //       if (res.status == 'ok') {
        //         if (level === 2) {
        //           resolve(
        //             res.data.ret.map(item => {
        //               item.leaf = 'leaf'
        //               return item
        //             })
        //           )
        //         } else {
        //           resolve(res.data.ret)
        //         }
        //       } else {
        //         this.$message.error('获取城市出错')
        //       }
        //     })
        //   }
        // }
      },
      // 标签弹框全局标签列表
      lPubDialogList:[],
      // 标签弹框私有标签列表
      lPriDialogList:[],
      // 添加标签弹框选中的标签
      diaTagChecks:[],
      // 简历id
      resumeIds:'',
      // 跟进记录
      followQuery:{
        resumeId:'', //简历id
        currpage: 1,
        perpage: 10
      },
      totalFollow: 0,
      // 服务记录 流程记录
      serviceQuery:{
        resumeId:'', //简历id
        roletype:localStorage.loginRoletype,
        currpage: 1,
        perpage: 10
      },
      totalService: 0,
      btnLoading:false,
      // 通知动态input的数量
      inputNum: 0,
      // 动态input的值
      inputList:[],
      matchQuery:{
        StrPlanstatus: '招聘中', // 招聘中或停招
        JobCategory: '',
        ResumeId:'',
        pageNum: 1,
        pageSize: 10
      },
      matchCount:0,
      // 添加的分配列表
      devUserList:[],
      addDivideQuery:{
        departName:'',
        Username:'',
        userIds:[]
      },
      // 选中的分配人员
      mulDivideList:[],
      devDataList:[],
      useridList:[],
      // 分配记录
      listRecordQuery: {
        perpage: 10,
        currpage: 1
      },
      rectotal:0,
      divRecordVisible:false,
      recLoading:false,
      recTableData:[],
      // 通知表头
      tableNoteTitle:[],
      // 弹框选中的全局标签
      dCheckCommonLabelList:[],
      // 弹框选中的私有标签
      dCheckPriLabelList:[],
      // 搜索选中的标签
      searchQuery:{
        includeContent:'不限',
        encludeContent:'不限'
      },
      //企微id
      qwuserid:'',
      // 登录id
      loginUserId:'',
      // 生成二维码
      codeQuery:{
        Id:'', // 岗位ID
        pagepath:'pages/enter/enter', // 页面URL
        strLinkType:'D' //A-报名二维码，B-到面二维码,C-入职二维码 D-简历采集二维(ID传空)
      },
      loginRoleType:'',
      // 面试时间列表
      viewTimeList:[],
      viewTimeQuery: {
        interviewStartTime: '',
        interviewEndTime: ''
      },
      // 有权限岗位列表
      resPostList:[],
      allPostList:[],
      resProjectList:[],
      faceLoading:false,
      // 是否能点击搜索按钮
      isSearchHandle:false,
      recommendLoading:false,
      // 按钮权限参数
      butQuery:{
        path:'/personalResources',
        powerEnName:'employee'
      },
      permissionLists:[]
    }
  },
  created() {
    this.loginUserId = Cookies.get("userid-b");
    this.loginRoleType = localStorage.loginRoletype
    if(!this.isNull(this.$route.query.active)){
      this.activeName = this.$route.query.active
    }else{
      this.activeName = '个人资源'
    }
    this.getButtonPower()
    this.getQUserid()
    // 部门列表
    this.getDepartList()
    this.calHeight()
    // 常用标签
    this.getCommonlabelLists()
    // 所有标签
    this.GetLabelManagement()
    // 获取省份
    this.getprovinces()
    // 意向岗位列表
    this.getIntendedPostList()
    // 获取简历来源
    this.getStateLists('118')
    // 意向岗位
    this.getTreestr()
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower(){
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if(that.checkPermission(['personalResources_page_list'],that.permissionLists)){
              that.getTableTitleLists()// 表头
            }
          }else{
            this.permissionLists = []
          }
        }else{
          this.permissionLists = []
        }
      })
    },
    // 确定约面
    saveSurfaceHandle(){
      let resList = []
      let that = this
      if(!this.isNull(this.surfaceTableData)){
        // 判断是否存在不能约面的数据
        if (that.surfaceTableData.some(v => v.Isopera == '1')) {
          this.$message({ type: 'warning', message: '存在不能约面的数据,不能操作,请查看提醒确认' })
          return false;
        }
        if(that.surfaceTableData.some(val => this.isNull(val.Projectid))){
          this.$message({ type: 'warning', message: '请选择项目' })
          return false
        }
        if(that.surfaceTableData.some(val => this.isNull(val.Jobid))){
          this.$message({ type: 'warning', message: '请选择岗位' })
          return false
        }
        if(that.surfaceTableData.some(val => this.isNull(val.appDtviewDate))){
          this.$message({ type: 'warning', message: '请选择面试日期' })
          return false
        }
        if(that.surfaceTableData.some(val => this.isNull(val.appDtviewTime))){
          this.$message({ type: 'warning', message: '请选择面试时间' })
          return false
        }
        for (let i = 0; i < this.surfaceTableData.length; i++) {
          const surEle = this.surfaceTableData[i];
          // if(this.isNull(surEle.Strremind)){
            resList.push({
                Jobid:surEle.Jobid, //岗位id
                Projectid:surEle.Projectid, //项目id
                ResumeId:surEle.ResumeId,//简历ID
                StrState:'约面',//当前状态
                StrRemark:surEle.StrRemark,//否决原因 离职原因等
                Dtviewtime:(!this.isNull(surEle.appDtviewDate)&&!this.isNull(surEle.appDtviewTime))?(surEle.appDtviewDate+' '+surEle.appDtviewTime.split('-')[0]):'',//面试时间
                Strviewadd:surEle.InterviewAddress,//面试地址
                Dtreachtime:'',//预计到岗时间
                DtInducttime:'',//入职时间
                StrIsphysical:'',//是否体检
                Strphysicalhos:'',//体检医院
                Dtquittime:'',//离职时间
                Strquittype:'',//离职类型
                StrIsBlack:!this.isNull(surEle.StrBlackReason)?'是':'否',//是否黑名单
                StrAccomreq:!this.isNull(surEle.StrAccomreq)?surEle.StrAccomreq:'',//住宿需求
                StrBlacklabel:!this.isNull(surEle.StrBlackReason)?surEle.StrBlackReason:'',//黑名单标签
                StrIdCard:!this.isNull(surEle.StrIdCard)?surEle.StrIdCard:''//身份证号码
            })
          // }
        }
          this.faceLoading = true
          // console.log('无空值，通过')  //false
          this.changeProcessRecord(resList,'约面')
      }else{
        this.$message({ type: 'warning', message: '没有要约面的数据' })
        return false
      }
      // console.log('ff',resList)
    },
    psnJobChange(val){
      // console.log('ii',this.$refs.matchRef)
      // 下拉框匹配
      let checkLabel = this.postList.find( item => item.Id ==val)
    },
    // 添加流程记录
    changeProcessRecord(query,type){
      xz.saveProcessRecords(query).then(res => {
        // console.log('11', res)
        if (res.status == 'ok') {
          this.$message({ type: 'success', message: '操作成功' })
          if(type == '约面'){
            this.surfaceVisible = false
            this.faceLoading = false
            this.$refs.child.getSignNum();
          }
          this.getList()
        }else{
          this.$message({ type: 'error', message: res.msg })
        }
      })
    },
    // 约面选择项目
    surProChange(item){
      // 匹配对于项目id的项目名称
      let selectedName = {};
      // 获取岗位列表
      let postArr = []
      this.$set(item, 'Jobid', '');
      this.$set(item, 'JobName', '');
      this.$set(item, 'Dtviewtime', '');
      this.$set(item, 'appDtviewDate', '');
      this.$set(item, 'appDtviewTime', '');
      this.$set(item, 'StrNeedAmount', '');
      this.$set(item, 'Strremind', '');
      this.$set(item, 'viewTimesList', []);
      this.$set(item, 'viewDateList', []);
      if(!this.isNull(item.Projectid)){
        selectedName = this.resProjectList.find((res)=>{
          return item.Projectid == res.Projectid;
        });
        // console.log('333',item,selectedName)
        this.$set(item, 'ProjectidnewName', selectedName.StrprojectName);
        this.$set(item, 'Projectid', selectedName.Projectid);
        this.$set(item, 'ProjectName', selectedName.StrprojectName);
        if(!this.isNull(this.allPostList)){
          for (let k = 0; k < this.allPostList.length; k++) {
            let element07 = this.allPostList[k];
            if(element07.Projectid == selectedName.Projectid){
              postArr.push({
                Id: element07.Id,
                JobCategory: element07.CustomerJobName
              })
            }
          }
          this.$set(item,'resPostList', postArr);
        }
      }
    },
    // 约面选择岗位
    surPostChange(item){
      let selectedName = {};
      this.$set(item, 'Dtviewtime', '');
      this.$set(item, 'appDtviewDate', '');
      this.$set(item, 'appDtviewTime', '');
      this.$set(item, 'StrNeedAmount', '');
      this.$set(item, 'Strremind', '');
      this.$set(item, 'viewTimesList',[]);
      if(!this.isNull(item.Jobid)){
        selectedName = item.resPostList.find((res)=>{
          return item.Jobid == res.Id;
        });
        this.$set(item, 'JobName', selectedName.JobCategory);
        this.$set(item, 'Jobid', selectedName.Id);
        let checkList = [{
          resumeId: this.isNullNotZero(item.ResumeId)?'0':item.ResumeId, // 简历id
          projectid: item.Projectid, // 项目id
          jobid: item.Jobid
        }]
        // 判断约面超额
        xz.getresumestatuscheck('约面',checkList).then(res => {
          // console.log('checkList', res)
          if (res.status == 'ok') {
            if(!this.isNull(res.msg)){
              this.$set(item, 'StrNeedAmount', res.msg[0].StrNeedAmount);
              this.$set(item, 'Strremind', res.msg[0].Strremind);
              this.$set(item, 'Isopera', res.msg[0].Isopera);
            }
          }
        });
        // 根据岗位获取面试时间列表
        let nowdate = moment().format("YYYY-MM-DD HH:mm")
        let endDate = moment().add(1,'months').format("YYYY-MM-DD HH:mm")
        let viewTimeQuery = {
          interviewStartTime: nowdate,
          interviewEndTime: endDate
        }
        xz.getjobdateappoint(selectedName.Id,viewTimeQuery).then(res => {
          // console.log('getTimeList', res)
          if (res.status == 'ok') {
            this.$set(item,'viewDateList',res.data);
          }
        });
      }
    },
    // 根据面试日期获取面试时间
    diaSurdateChange(item){
      this.$set(item, 'appDtviewTime', '');
      let viewTimeQuery = {
        interviewTime: item.appDtviewDate
      }
      if(!this.isNull(item.Jobid)&&(!this.isNull(item.appDtviewDate))){
        xz.getjobappointtime(item.Jobid,viewTimeQuery).then(res => {
          // console.log('getTimeList', res)
          if (res.status == 'ok') {
            this.$set(item,'viewTimesList',res.data);
          }
        });
      }
    },
    // 约面弹框
    surDialogHandle(){
      if(this.isNull(this.multipleSelection)){
        this.$message({ type: 'warning', message: '请选择要约面的数据' })
        return false;
      }else{
        this.getResourceJoblist()
        this.surfaceVisible = true
        // this.getresumestatuscheck('约面','surface')
        this.surfaceTableData = this.multipleSelection
        if(!this.isNull(this.surfaceTableData)){
          for (let i = 0; i < this.surfaceTableData.length; i++) {
            let eleFace01 = this.surfaceTableData[i];
            this.$set(eleFace01,'resPostList', []);
            this.$set(eleFace01,'Jobid', '');
            this.$set(eleFace01,'Projectid', '');
            this.$set(eleFace01,'StrRemark', '');
            this.$set(eleFace01,'Dtviewtime', '');
            this.$set(eleFace01,'StrNeedAmount', '');
            this.$set(eleFace01,'Strremind', '');
            this.$set(eleFace01,'appDtviewDate', '');
            this.$set(eleFace01,'appDtviewTime', '');
            this.$set(eleFace01,'StrAccomreq', '');
            this.$set(eleFace01,'viewDateList', []);
            this.$set(eleFace01,'viewTimesList', []);
          }
        }
        // console.log('项目名称列表', this.surfaceTableData)
      }
    },
    // 获取有权限的项目列表和岗位列表
    getResourceJoblist(){
      xz.getresourcechangejoblist({},localStorage.loginRoletype).then(res => {
        if (res.status == 'ok') {
          // console.log(99,res)
          this.resProjectList = res.data.retList
          // 项目列表去重
          let obj = {};
          let peon = this.resProjectList.reduce((cur,next) => {
              obj[next.StrprojectName] ? "" : obj[next.StrprojectName] = true && cur.push(next);
              return cur;
          },[]) //设置cur默认类型为数组，并且初始值为空的数组
          this.resProjectList = peon
          this.allPostList = res.data.retList
          // console.log('11', this.allPostList)
        }
      })
    },
    // 获取岗位列表
    getPostList(projectid){
      this.resPostList = []
      if(!this.isNull(this.allPostList)){
        for (let i = 0; i < this.allPostList.length; i++) {
          let element07 = this.allPostList[i];
          if(element07.Projectid == projectid){
            this.resPostList.push({
              Id: element07.Id,
              JobCategory: element07.CustomerJobName
            })
          }
        }
        // console.log('22', this.resPostList)
      }
    },
    // 根据岗位获取面试时间列表
    getTimeList(jobid){
      let nowdate = moment().format("YYYY-MM-DD HH:mm")
      let endDate = moment().add(1,'months').format("YYYY-MM-DD HH:mm")
      this.viewTimeQuery = {
        interviewStartTime: nowdate,
        interviewEndTime: endDate
      }
      this.viewTimeList = []
      xz.getresourceavailabletime(jobid,this.viewTimeQuery).then(res => {
        // console.log('getTimeList', res)
        if (res.status == 'ok') {
          // console.log(99,res)
          this.viewTimeList = res.data.tempList
        }
      })
    },
    // 一键同步
    syncHandle(){
      // console.log('getqwUserid', this.qwuserid)
      xz.getfollowuserc(this.qwuserid).then(res => {
        // console.log('getqwUserid', res)
        if (res.status == 'ok') {
          this.$message({ type: 'success', message: '同步中，请等候几分钟。' })
          this.getList()
        }else{
          this.$message({ type: 'error', message: '操作失败，请稍后再试' })
        }
      })
    },
    // 获取企业微信ID
    getQUserid(){
      if(this.loginid == 'caa39434-539c-40cb-95d6-31b215f0f9dc'){// testadmin
        this.qwuserid = ''
        this.isQwHandle = true
        // console.log('getqwUserid', this.loginid)
      }else{
        xz.getqwUserid().then(res => {
          // console.log('getqwUserid', res)
          if (res.status == 'ok') {
            if(res.totalcount > 0){
              this.qwuserid = res.msg
              if(!this.isNull(this.qwuserid)){
                this.isQwHandle = true
              }else{
                this.isQwHandle = false
              }
            }
          }
        })
      }
    },
    // 选择搜索包含标签
    inSearchHandle(){
      let inAllList01 = []
      let inList01 = []
      let inList02 = []
      let allLabelList = this.publicList.concat(this.privateList) // 所有标签
      let allSelectList = []; // 选中的标签名
      inList01 = this.includeCheckList01.concat(this.includeLabelChecks)
      inList02 = this.includeCheckList02.concat(this.includeLabelChecks)
      inAllList01 = inList01.concat(inList02)
      //去重
      inAllList01 = [...new Set(inAllList01)];
      this.listQuery.strlabelbh = inAllList01.toString()
      for (let i = 0; i < allLabelList.length; i++) {
        let elementlabel01 = allLabelList[i].LbGroupVallist;
          elementlabel01.filter((item) => {
            if (inAllList01.indexOf(item.Id) > -1) {
              allSelectList.push(item.LableName);
            }
          })
      }
      this.searchQuery.includeContent = allSelectList.join("、")
      this.includeSearchVisible = false
      // console.log('allSelectList',allLabelList,allSelectList)
    },
    // 选择搜索排除标签
    enSearchHandle(){
      let inAllList02 = []
      let enList01 = []
      let enList02 = []
      let allLabelList = this.publicList.concat(this.privateList) // 所有标签
      let allSelectList = []; // 选中的标签名
      enList01 = this.encludeCheckList01.concat(this.excludeLabelChecks)
      enList02 = this.encludeCheckList02.concat(this.excludeLabelChecks)
      inAllList02 = enList01.concat(enList02)
      //去重
      inAllList02 = [...new Set(inAllList02)];
      this.listQuery.strlabelpc = inAllList02.toString()
      for (let i = 0; i < allLabelList.length; i++) {
        let elementlabel02 = allLabelList[i].LbGroupVallist;
          elementlabel02.filter((item) => {
            if (inAllList02.indexOf(item.Id) > -1) {
              allSelectList.push(item.LableName);
            }
          })
      }
      this.searchQuery.encludeContent = allSelectList.join("、")
      this.encludeSearchVisible = false
      // console.log('allSelectList',allLabelList,allSelectList)
    },
    // 搜索意向地区
    changeSearchArea(val){
      if(!this.isNull(val)){
        let checkedNode =  this.$refs["cascaderSearArr"].panel.getNodeByValue(val);
        this.listQuery.StrUserCityCode = val.toString()
        let labels = checkedNode.pathLabels
        this.listQuery.strUserCity = labels.join('-')
        this.listQuery.strCityCode = val
      }else{
        this.listQuery.strCityCode = ''
      }
    },
     // 获取分配列表
    getRecordList(){
        this.recLoading = true
        xz.getdistrecords(this.listRecordQuery).then(res => {
            // console.log('22', res)
            if (res.status == 'ok') {
              this.recTableData = res.msg
              this.rectotal = res.totalcount
            }
            this.recLoading = false
          })
    },
    //分页
    recCurrentChange(val){
        this.listRecordQuery.currpage = Number(val)
        this.getRecordList()
    },
    recSizeChange(val) {
        this.listRecordQuery.currpage = 1
        this.listRecordQuery.perpage = Number(val)
        this.getRecordList()
    },
    getRowKeys(row) { //唯一值
      // console.log(row.id)
      return row.userIds;
    },
    // // 选择分配人员多选
    // dviSelectionChange(val) {
    //   // console.log('11',val)
    //   this.mulDivideList = val;
    //   if(!this.isNull(val)){
    //     this.useridList = this.useridList.concat(val)
    //     // 去重
    //     const mapj = new Map()
    //     const qc = this.useridList.filter(key => !mapj.has(key.userIds) && mapj.set(key.userIds, 1))
    //     this.useridList = qc
    //   }
    //   if(!this.isNull(this.useridList)){
    //     for (let j = 0; j < this.useridList.length; j++) {
    //       const elementj = this.useridList[j];
    //       this.devUserList.push(elementj.userIds)
    //     }
    //   }
    //   //去重
    //   this.devUserList = [...new Set(this.devUserList)];
    //   // console.log('22', this.useridList, this.devUserList)
    // },
    // 删除分配列表
    dltDivideHandle(data,index){
      data.splice(index, 1)
    },
    // 事件处理函数
    async fatherChange(value) {
      // console.log('fatherChange',value)
      this.curractive = value
    },
    //导入-确认返回
    backHandle() {
      this.importVisible = false
      location.reload();
      // this.getList();
    },
    //查看导入结果
    resultHandle() {
      this.importVisible = false
        this.$router.push({
            path: "/resImportList",
            query:{
              active:'导入导出记录'
            }
        })
    },
    // 人岗匹配列表
    getMatchList(){
      this.recommendLoading = true
      xz.wxappgetjoblist(this.roleType,this.matchQuery).then(res => {
        // console.log('getMatchList', res)
        if (res.status == 'ok') {
          this.recommendList = res.data.retList
          this.matchCount = res.data.count
        }else{
          this.recommendList = []
          this.matchCount = 0
        }
        this.recommendLoading = false
      })
    },
    recommendCurrentChange(val){
      this.matchQuery.pageNum = Number(val)
      this.getMatchList()
    },
    recommendSizeChange(val){
      this.matchQuery.pageNum = 1
      this.matchQuery.pageSize = Number(val)
      this.getMatchList()
    },
    // 保存录入简历
    saveEnterHandle(){
      this.enterBtnType = 'save'
      this.enterResumeQuery.StrPsnIsType = '0'
      this.enterResumeQuery.StrCategoryIds = this.enterResumeQuery.posCategoryList.toString()
      if(this.isNull(this.enterResumeQuery.salary1)&&this.isNull(this.enterResumeQuery.salary2)){
        this.enterResumeQuery.StrUserExpectSa = ''
      }else if(!this.isNull(this.enterResumeQuery.salary1)&&this.isNull(this.enterResumeQuery.salary2)){
        this.$message({ type: 'warning', message: '请填写最高期望薪资' })
        return false
      }else if(this.isNull(this.enterResumeQuery.salary1)&&!this.isNull(this.enterResumeQuery.salary2)){
        this.$message({ type: 'warning', message: '请填写最低期望薪资' })
        return false
      }else if(Number(this.enterResumeQuery.salary1)>Number(this.enterResumeQuery.salary2)){
        this.$message({ type: 'warning', message: '最低期望薪资不能高于最高薪资' })
        return false
      }else{
        this.enterResumeQuery.StrUserExpectSa = this.enterResumeQuery.salary1+'-'+this.enterResumeQuery.salary2
      }
      this.enTagChecks = [...new Set(this.enTagChecks)]
      // console.log('sss', this.enterResumeQuery,this.enTagChecks)
      this.$refs['enterResumeForm'].validate((valid) => {
        if (valid) {
          xz.saveResumeinfo(this.enterResumeQuery).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.enterResumeQuery.ResumeId = res.msg
              if(this.isNull(this.enTagChecks)){
                this.enterResumeVisible = false
                this.$message({ type: 'success', message: '录入成功' })
                this.getList()
              }else{
                this.enterTagQuery = {
                  resumeIds: this.enterResumeQuery.ResumeId, // 简历id (多条用,连接)
                  labelIds: this.enTagChecks.toString() // 标签id (多条用,连接)
                }
                this.tagHandle(this.enterTagQuery, 'enter')
                this.getList()
              }
            }else{
              this.$message({ type: 'error', message: res.msg })
            }
          })
        } else {
          return false;
        }
      })
    },
    // 保存分配简历人员
    saveDivideHandle(){
      if(this.isNull(this.divideQuery.resumeIds)){
        this.$message({ type: 'warning', message: '请选择分配的数据' })
        return false
      }
      if(this.isNull(this.divideQuery.perDepartList)){
        this.$message({ type: 'warning', message: '请选择部门' })
        return false
      }
      // console.log('saveEnterHandle', this.devUserList)
      if(!this.isNull(this.devUserList)){
        this.divideQuery.userIds = this.devUserList.toString()
      }
      this.divLoading = true
      this.$refs['divideForm'].validate((valid) => {
        if (valid) {
          // 不选部门传部门下的所有人员
          // if(this.isNull(this.dividePersonList)){
          //   let onesList = []
          //   for (let i = 0; i < this.memberList.length; i++) {
          //     const elementMem = this.memberList[i];
          //     onesList.push(elementMem.Userid)
          //   }
          //   this.divideQuery.userIds = onesList.toString()
          // }else{
          // }
          // console.log('saveEnterHandle', this.divideQuery)
          xz.distResumeinfo(this.divideQuery).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              if(res.totalcount == 0){
                this.$message({ type: 'warning', message: '简历已达到上限' })
                return false
              }else{
                this.$message({ type: 'success', message: '操作成功' })
                this.divideVisible = false
                this.getRecordList()
                this.divRecordVisible = true
                this.getList()
              }
            }else{
              this.$message({ type: 'error', message: '操作失败，请稍后再试' })
            }
            this.divLoading = false
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    // 选择通知模板
    tempHandle(val){
      // console.log('dd',val)
      for (let i = 0; i < this.noticeTempList.length; i++) {
          const elementtmp = this.noticeTempList[i];
          if(val == elementtmp.Id){
            this.moduleInfo = elementtmp.TemplateVal
            this.tableNoteTitle = JSON.parse(elementtmp.Parameter)
          }
        }
        this.inputNum = Number(this.sGetCharCount(this.moduleInfo, '{') - 2)
    },
    // 查询字符的数量
    sGetCharCount(str,char) {
      let regex = new RegExp(char, 'g');
      let result = str.match(regex);
      let count=!result ? 0 : result.length;
      return count;
    },
    // 提交消息通知
    saveNoticeHandle(){
      if(this.isNull(this.noticeData)){
        this.$message({ type: 'warning', message: '请选择要通知的数据' })
        return false;
      }else{
        let parameterList = {}
        for (let i = 0; i < this.noticeData.length; i++) {
          const elementw = this.noticeData[i];
         for (let k = 0; k < this.tableNoteTitle.length; k++) {
            const element09 = this.tableNoteTitle[k];
            this.$set(parameterList, element09.StrColumId, elementw[element09.StrColumId])
          }
          this.noticeQuery.SendList.push(
            {
              usermobil: elementw.StrMobile,
              Parameter: parameterList
            }
          )
          // 判断是否有空值
          if (Object.values(parameterList).some(v => v === '')) {
            this.$message({ type: 'warning', message: '请填写数据' })
            return false;
          }
        }
        // console.log('noticeQuery', this.noticeQuery)
        xz.sendnotify(this.roleType,this.noticeQuery).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.noticeVisible = false
              this.multipleSelection = []
              this.getList()
              this.$message({ type: 'success', message: '操作成功' })
            }else{
              this.$message({ type: 'error', message: '操作失败，请稍后再试' })
            }
          })
      }
    },
    // 保存编辑标签
    saveLabelHandle(){
      this.diaTagChecks = this.dCheckPriLabelList.concat(this.dCheckCommonLabelList)
      //去重
      this.diaTagChecks = [...new Set(this.diaTagChecks)];
      let ids = this.diaTagChecks.toString()
      // console.log('uuu',this.diaTagChecks)
      if(this.isNull(this.diaTagChecks)){
        this.$message({ type: 'warning', message: '请选择标签' })
        return false
      }else{
        this.tagHandle({resumeIds:this.resumeIds,labelIds:ids}, 'dialog')
        // this.getList()
      }
    },
    // 保存跟进
    saveFollowHandle(){
      // this.recommendQuery.StrUserJobhunt = this.recommendQuery.fCheckList.toString()
      this.$refs['followForm'].validate((valid) => {
        if (valid) {
          xz.savePsnfowrecords(this.recommendQuery).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.getFollowList()
              this.$message({ type: 'success', message: '操作成功' })
            }else{
              this.$message({ type: 'error', message: '操作失败，请稍后再试' })
            }
          })
        } else {
          return false;
        }
      })
    },
    //分页(服务记录/跟进记录)
    handleCurrentChange1(val){
        this.followQuery.currpage = Number(val)
        this.getFollowList()
    },
    handleSizeChange1(val) {
        this.followQuery.currpage = 1
        this.followQuery.perpage = Number(val)
      this.getFollowList()
    },
    handleCurrentChange2(val){
        this.serviceQuery.currpage = Number(val)
        this.getServiceList()
    },
    handleSizeChange2(val) {
        this.serviceQuery.currpage = 1
        this.serviceQuery.perpage = Number(val)
      this.getServiceList()
    },
    //获取跟进记录
    getFollowList() {
      this.followLoading = true
      xz.getresumePsnfowrecords(this.followQuery).then(res => {
        // console.log('followQuery', res)
        if (res.status == 'ok') {
          this.followData = res.msg
          this.totalFollow = res.totalcount
        } else {
          this.followData = []
          this.totalFollow = 0
        }
        this.followLoading = false
      })
    },
    //获取服务记录 流程记录
    getServiceList() {
      this.serviceLoading = true
      xz.getresumePsnstatusrecords(this.serviceQuery).then(res => {
        // console.log('serviceQuery', res)
        if (res.status == 'ok') {
          this.serviceData = res.msg
          this.totalService = res.totalcount
        } else {
          this.serviceData = []
          this.totalService = 0
        }
        this.serviceLoading = false
      })
    },
    // 标签弹框 选择公有标签
    dPubEnterHandle(val){
      this.dCheckCommonLabelList = []
      // console.log('labelEnterHandle', val)
      this.dCheckCommonLabelList = val
    },
    // 标签弹框 选择私有标签
    dPraEnterHandle(val){
      this.dCheckPriLabelList = []
      // console.log('lPraEnterHandle', val)
      this.dCheckPriLabelList = val
    },
    // 打标签
    tagHandle(query, type){
      // console.log('tagHandle', query)
      xz.savelabelResume(query).then(res => {
        // console.log('tagHandle', res)
        if (res.status == 'ok') {
          if(type == 'dialog'){
            this.getresumelabelLists(query.resumeIds)
            this.addlabelVisible = false
          }
          if(type == 'enter'){
            this.enterResumeVisible = false
          }
          this.$message({ type: 'success', message: '操作成功' })
        }else{
          this.$message({ type: 'error', message: '操作失败,请稍后再试' })
        }
      })
    },
    //选择地址
    changeArea(val) {
      // console.log('ddd', val)
      let checkedNode;
      let labels;
      if(!this.isNull(val)){
        checkedNode = this.$refs["cascaderArr"].panel.getNodeByValue(val);
        labels = checkedNode.pathLabels;
        // console.log( checkedNode ) ;  //获取当前点击节点的label值
        // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
        this.enterResumeQuery.StrUserCityCode = val.toString()
        this.enterResumeQuery.StrUserCity = labels.join('-')
      }else{
        this.enterResumeQuery.StrUserCityCode = ''
        this.enterResumeQuery.StrUserCity = ''
      }
      this.strCityCode = val
    },
    // 简历导入弹框
    importHandle(){
      this.importVisible = true
    },
    // 录入弹框
    enterHandle(){
      // 初始化-清空
      // Object.assign(this.$data, this.$options.data())
      this.enterResumeQuery = this.$options.data.call(this).enterResumeQuery
      this.includePublicChecks = []
      this.includePrivateChecks = []
      this.strCityCode = []
      this.enterNoteTxt = false
      // this.getTreestr()
      this.enterBtnType = ''
      this.enterResumeVisible = true
    },
    // 分配弹框
    divideHandle(){
      this.divideQuery.userIds = ''
      this.divideQuery.perDepartList = []
      this.dividePersonList = []
      this.devUserList = []
      this.devDataList = []
      this.addDivideQuery = {
        departName:'',
        Username:'',
        userIds:[]
      }
      // if(this.isNull(this.multipleSelection)){
      //   this.$message({ type: 'warning', message: '请选择分配的数据' })
      //   return false
      // }else{
        this.divideVisible = true
      // }
    },
    // 通知弹框
    noticeHandle(){
      this.noticeQuery.TemplateId = ''
      this.moduleInfo = ''
      this.inputNum = 0
      this.tableNoteTitle = []
      if(this.isNull(this.noticeData)){
        this.$message({ type: 'warning', message: '请选择要通知的数据' })
        return false;
      }else{
        // 获取消息模板列表
        this.getTemplateList()
        this.noticeVisible = true
      }
    },
    // 标签弹框
    labelHandle(item){
      this.resumeIds = item.ResumeId
      this.getresumelabelLists(item.ResumeId)
      this.labelVisible = true
    },
    // 添加标签弹框
    addLabelHandle(){
      // 全局标签
      for (let i = 0; i < this.lPubDialogList.length; i++) {
        const elementl1 = this.lPubDialogList[i];
        this.wholeCheckList.push(elementl1.LabelId)
      }
      // 私有
      for (let j = 0; j < this.lPriDialogList.length; j++) {
        const elementl2 = this.lPriDialogList[j];
        this.wholeCheckList2.push(elementl2.LabelId)
      }
      this.dCheckPriLabelList = this.wholeCheckList2
      this.dCheckCommonLabelList = this.wholeCheckList
      this.diaTagChecks = this.wholeCheckList.concat(this.wholeCheckList2)
      // console.log('rrr',this.diaTagChecks,this.wholeCheckList2)
      this.addlabelVisible = true
    },
    // 跟进弹框
    followHandle(item){
      this.matchQuery.ResumeId = item.ResumeId
      this.followQuery.resumeId = item.ResumeId
      this.serviceQuery.resumeId = item.ResumeId
      this.recommendQuery = {
        ResumeId: item.ResumeId, // 简历id
        StrUserJobhunt:'', // 求职意愿
        StrReason:'', // 原因
        StrRemark:'', // 备注
        GduserId: Cookies.get("userid-b"), // 操作人
        GduserName:'', // 操作人姓名
        StrOther:'', // 其他
        fCheckList: []
      }
      // console.log('iy',this.recommendQuery)
      // 人岗匹配列表
      this.getMatchList()
      this.getFollowList()
      // 服务列表
      this.getServiceList()
      this.followVisible = true
    },
    // 详情
    dtlHandle(item){
      let routeUrl = this.$router.resolve(
        { path: '/dtlResource',query:{
          id: item.ResumeId,
          pageTitle:'个人资源'
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    handleClick(tab){
      // console.log('dd',tab)
      this.activeName = tab.name
      if(tab.name == '公海资源'){
        this.$router.push({
            path: '/publicResources',
            query:{
                active:'公海资源'
            }
        })
      }
    },
    // 添加标签切换
    handleLabelClick(tab, event){},
    // 跟进切换
    followHandleClick(tab, event){
      // if(tab.name == '跟进记录'){
      //   this.getFollowList()
      // }else if(tab.name == '服务记录'){
      //   this.getServiceList()
      // }
    },
    // 获取简历标签详情
    getresumelabelLists(resumeId){
      this.includePublicChecks = []
      this.includePrivateChecks = []
      xz.GetresumelabelLists({resumeId: resumeId}).then(res => {
          // console.log('getresumelabelLists', res)
          if (res.status == 'ok') {
            this.lPubDialogList = res.msgpub
            this.lPriDialogList = res.msgpri
            // 公共标签
            if(!this.isNull(res.msgpub)){
              for (let i = 0; i < res.msgpub.length; i++) {
                const elementpub = res.msgpub[i];
                this.enTagChecks.push(elementpub.LabelId)
                this.includePublicChecks.push(elementpub.LabelId)
              }
            }
            // 私有标签
            if(!this.isNull(res.msgpri)){
              for (let j = 0; j < res.msgpri.length; j++) {
                const elementpri = res.msgpri[j];
                this.enTagChecks.push(elementpri.LabelId)
                this.includePrivateChecks.push(elementpri.LabelId)
              }
            }
          }
        })
    },
    // 岗位类别选择
    poSectionChange(val){
      // console.log('poSectionChange', val)
      const checkedNode =  this.$refs['poSectionArr'].getCheckedNodes();
      // console.log( checkedNode[0].data.strParametername ) ;  //获取当前点击节点的label值
      // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
      let labels = checkedNode[0].pathLabels;
      if(labels.length > 1){
        this.enterResumeQuery.StrJobInf = labels[1];
      }else if(labels.length == 1){
        this.enterResumeQuery.StrJobInf = labels[0];
      }
    },
    // 搜索岗位选择
    poSearchChange(){
      const checkedNode1 =  this.$refs['poSearchArr'].getCheckedNodes();
      let labels = checkedNode1[0].pathLabels;
      if(labels.length > 1){
        this.listQuery.strJobInf = labels[1];
      }else if(labels.length == 1){
        this.listQuery.strJobInf = labels[0];
      }
    },
    // 查询发送记录
    jumpSendRecord(){
      let routeUrl = this.$router.resolve(
        { path: '/noteSendList'
      });
      window.open(routeUrl.href, '_blank');
    },
    // 验证手机号
    checkHandle(chkval, callback){
      if (chkval.length > 0) {
        xz.checkResumeMobile({strMobile: chkval}).then(res => {
          // console.log('checkHandle', res)
          if (res.status == 'ok') {
            if(Number(res.msg) > 0){
              this.enterResumeQuery.ResumeId = res.msg
              callback(true)
            }else{
              callback(false)
            }
          }
        })
      }
      
    },
    // 获取简历详情
    getResumeDtl(id){
      xz.getResumeDetail({ResumeId: id}).then(res => {
        // console.log('getResumeDtl', res)
        if (res.status == 'ok') {
          let resMsg = res.msg
          let resMsgp = res.msgp
          this.enterNoteTxt = true
          this.enterResumeQuery = {
        ResumeId: resMsg.ResumeId, //简历ID
        StrUserName: resMsg.StrUserName, //姓名
        StrMobile: resMsg.StrMobile, //联系方式
        StrWorkState: resMsg.StrWorkState, //当前状态
        BolUserSex: resMsg.BolUserSex, //性别
        StrUserAge: resMsg.StrUserAge, //年龄
        StrNativePlace: resMsg.StrNativePlace, //户籍
        StrEduLvl: resMsg.StrEduLvl, //学历
        StrJobInf: resMsg.StrJobInf, //意向岗位
        StrCategoryIds: resMsg.StrCategoryIds, //意向岗位id
        // 选中的意向岗位
        posCategoryList: [],
        StrUserCity: resMsg.StrUserCity, //求职城市
        StrUserAdd: resMsg.StrUserAdd, //居住地
        StrUserCityCode: resMsg.StrUserCityCode, //求职城市code
        StrSource: resMsg.StrSource, //来源
        StrUserExpectSa: resMsg.StrUserExpectSa, //期望薪资
        salary1: !this.isNull(resMsg.StrUserExpectSa)?resMsg.StrUserExpectSa.split('-')[0]:'',
        salary2: !this.isNull(resMsg.StrUserExpectSa)?resMsg.StrUserExpectSa.split('-')[1]:'',
        StrRemark: resMsg.StrRemark, //备注
        StrlateCompany: resMsg.StrlateCompany, //最近入职项目
        DtlateInducDate: !this.isNull(resMsg.DtlateInducDate)?resMsg.DtlateInducDate:'', //最近入职时间
        DtlatequitDate: !this.isNull(resMsg.DtlatequitDate)?resMsg.DtlatequitDate:'', //最近离职时间
        StrquitReason: resMsg.StrquitReason, //离职原因
        StrUserJobhunt: resMsg.StrUserJobhunt, //求职意向
        StrPsnIsType: resMsg.StrPsnIsType, //是否公海 1 公海 0私人
        StrJobType: resMsg.StrJobType, //岗位类型
        StrState: resMsg.StrState, //在离职状态
        //拓展
        StrIsBlack: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrIsBlack)?resMsgp.StrIsBlack:'', //是否黑名单
        StrBlackReason: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrBlackReason)?resMsgp.StrBlackReason:'', //黑名单原因
        StrUsernation: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrUsernation)?resMsgp.StrUsernation:'', //民族
        Strskill: !this.isNull(resMsgp)&&!this.isNull(resMsgp.Strskill)?resMsgp.Strskill:'', //技能
        Strcertificate: !this.isNull(resMsgp)&&!this.isNull(resMsgp.Strcertificate)?resMsgp.Strcertificate:'', //证书
        StrAccomreq: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrAccomreq)?resMsgp.StrAccomreq:'', //住宿要求
        StrDinreq: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrDinreq)?resMsgp.StrDinreq:'', //吃饭要求
        StrIsqwfri: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrIsqwfri)?resMsgp.StrIsqwfri:'', //是否企微好友
        StrCont1: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont1)?resMsgp.StrCont1:'', //拓展1
        StrCont2: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont2)?resMsgp.StrCont2:'',
        StrCont3: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont3)?resMsgp.StrCont3:'',
        StrCont4: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont4)?resMsgp.StrCont4:'',
        StrCont5: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont5)?resMsgp.StrCont5:'',
        StrCont6: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont6)?resMsgp.StrCont6:'',
        StrCont7: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont7)?resMsgp.StrCont7:'',
        StrCont8: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont8)?resMsgp.StrCont8:'',
        StrCont9: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont9)?resMsgp.StrCont9:'',
        StrCont10: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont10)?resMsgp.StrCont10:'',
        WorkingShift: resMsgp.WorkingShift, // 班次
        Workingposition: resMsgp.Workingposition, // 站班/坐班
        StrResumefile: resMsg.StrResumefile, // 简历附件名称
        StrResumefileUrl: resMsg.StrResumefileUrl // 简历附件路径
        }
        this.strCityCode = resMsg.StrUserCityCode?resMsg.StrUserCityCode.split(','):[]
        this.getresumelabelLists(resMsg.ResumeId)
        this.enterResumeQuery.posCategoryList = resMsg.StrCategoryIds?resMsg.StrCategoryIds.split(','):[]
        // console.log('iii', this.$refs[`cascaderArr`])
        this.$nextTick(() => {this.$refs[`cascaderArr`].inputValue = resMsg.StrUserCity})
        }
      })
    },
    //获取省份
    getprovinces() {
      xz.getAreaAll().then(res => {
        // console.log('getprovinces', res)
        // if (res.status == 'ok') {
          this.provinces = res;
        // } else {
        //   this.provinces = [];
        // }
      })
    },
    // 意向岗位 岗位类别
    getTreestr() {
      let data = {
        currpage: 1,
        perpage: 10000,
        strIsDisable:'', // 传1 禁用的看不到了  不传就全显示
        keyword: ''
      }
      xz.getTreestr('JB_base_Jobcategory', data).then(res => {
        if (res) {
          this.intendedPost = res.msg.parent
        } else {
          this.intendedPost = []
        }
      })
    },
    // 人岗匹配岗位
    getIntendedPostList(){
      let hotQuery = {
        seachStr: '招聘中',
        roletype: localStorage.loginRoletype
      }
      xz.gethotjobopeningslist(hotQuery.seachStr,hotQuery.roletype).then(res => {
        // console.log('getPostList', res)
        if (res.status == 'ok') {
          this.postList = res.data;
        } else {
          this.postList = [];
        }
      })
    },
    // 批量投放公海
    launchAllHandle(){
      if(this.isNull(this.multipleSelection)){
        this.$message({ type: 'warning', message: '请选择简历投放公海' })
        return false
      }else{
        this.$confirm('是否投放公海?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveLaunchHandle(this.injectQuery.resumeIds)
        }).catch(() => {
          console.log('已取消')
        })
      }
    },
    // 投放公海
    launchHandle(item){
      this.$confirm('是否投放公海?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.saveLaunchHandle(item.ResumeId)
      }).catch(() => {
        console.log('已取消')
      })
    },
    // 保存投放公海
    saveLaunchHandle(id){
      // console.log('saveLaunchHandle', id)
      if(this.isNull(id)){
        this.$message({ type: 'warning', message: '请选择简历投放公海' })
        return false
      }else{
        xz.LaunchResumepublic({resumeIds:id}).then(res => {
          // console.log('saveLaunchHandle', res)
         if (res.status == 'ok') {
            this.getList()
            this.$message({ type: 'success', message: '操作成功' })
          }else{
            this.$message({ type: 'error', message: '操作失败，请稍后再试' })
          }
        })
      }
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    // 表格多选
    handleSelectionChange(val) {
      // console.log('yyy',val)
      this.noticeData = val
      let resumeIdList = []
      this.multipleSelection = val;
      if(!this.isNull(val)){
        for (let i = 0; i < val.length; i++) {
          const elementval = val[i];
          resumeIdList.push(elementval.ResumeId)
        }
        this.injectQuery.resumeIds = resumeIdList.toString() // 简历id (多条用,连接)
        this.divideQuery.resumeIds = resumeIdList.toString()
      }
    },
    //数组去重
    unique(arr) {
      for (let i = 0; i < arr.length; i++) {
        for(let j = i+1; j < arr.length; j++){
          if(arr[i].toString()==arr[j].toString()){
            arr.splice(j,1);
            j--;
          }
        }
      }
      return arr;
    },
    // 限制并转换选中的值
    changeDataHandle(departNum,departList,val) {
      for (let i = 0; i < departNum.length; i++) {
        let val01 = departNum[i]
        let devUserNum = 0 //每个部门的人数
        for(let j = 0; j < val.length; j++){
          let val02 = val[j]
          if(val02[Number(val02.length)-1].length<20){
            if(val01.toString() == val02.toString()){
              departList.push(val01)
            }
          }else{
            // 同一个部门时
            if(val01.toString() == val02.slice(0,val02.length-1).toString()){
              // 每个部门最多5个人
              if(devUserNum < 5){
                departList.push(val02)
                devUserNum = devUserNum + 1
                this.isCheckDepart = false
              }else{
                this.isCheckDepart = true
              }
            }
          }
        }
      }
      departList = this.unique(departList)
      return departList;
    },
    // 选择部门
    perSectionChange(val){
        console.log('perSectionChange', val)
        let departList = []
        let departNum = [] //选中的部门
        this.devUserList = []
        let checkedNode =  this.$refs["departLabel"].getCheckedNodes();
        if(this.isNull(val)){
          this.divideQuery.perDepartList = []
        }else{
          for (let i = 0; i < val.length; i++) {
            let elementdepart = val[i];
            // 如果选的是部门 最多分配给五个部门
            if(elementdepart[Number(elementdepart.length)-1].length<20){
              departNum.push(elementdepart)
            }else{
              // 如果选了员工
              elementdepart = elementdepart.slice(0,elementdepart.length-1)
              departNum.push(elementdepart)
            }
            // 去重
            departNum = this.unique(departNum)
          }
          if(departNum.length>5){
              this.isCheckDepart = true
              departNum = departNum.splice(0,5)
            }else{
              this.isCheckDepart = false
          }
          departList = this.changeDataHandle(departNum,departList,val)
          this.divideQuery.perDepartList = departList
          
          for (let k = 0; k < this.divideQuery.perDepartList.length; k++) {
            const elementkk = this.divideQuery.perDepartList[k];
            this.devUserList.push(elementkk[Number(elementkk.length)-1])
          }
          // 父节点选中，那么所有子孙节点必然是选中的，则反推出：如果节点有父节点且父节点被选中了 过滤掉(全选和不选)
          checkedNode = checkedNode.filter(item => !(item.parent && item.parent.checked)); // 核心
          this['departLabel'] = checkedNode;
          // console.log( 'userList',val )
          // console.log( 'checkedNode',checkedNode[0],checkedNode[0].data.strType ) ;  //获取当前点击节点的label值
          // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
        }
    },
    // 复制链接
    repeatHandle(){
        // 后台传回的链接
        let url = 'https://dev.joball.net'
        navigator.clipboard.writeText(url).then(() => {
            this.$message.success('复制成功')
        })
    },
    //生成二维码
    cerateQCode(item) {
      this.getCode()
    },
    // 获取二维码
    getCode(){
      this.codeloading = true;
      xz.getapplyjoobqrcodegenerated(this.loginRoleType,this.codeQuery).then(res => {
        // console.log('eee', res)
        if (res.status == 'ok') {
          let result = res.data
          this.canvasImg = this.imgPath + result
        }
        this.codeloading = false
        // console.log('getStateLists', this.data.status)
      })
    },
    //分页
    handleCurrentChange(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
      this.getList()
    },
    // 获取消息模板列表
    getTemplateList(){
      xz.gettemplatelist(this.roleType,{ pageNum: 1, pageSize: 1000}).then(res => {
        console.log('gettemplatelist', res)
        if (res.status == 'ok') {
            this.noticeTempList = res.data
          }else{
            this.noticeTempList = []
          }
      })
    },
    // 获取列表
    getList(){
      this.tableLoading = true
      this.isSearchHandle = true
      xz.getprivateResumeLists(this.listQuery).then(res => {
        // console.log('getList', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.total = res.totalcount
        }else{
          this.tableData = []
          this.total = 0
        }
        this.isSearchHandle = false
        this.tableLoading = false
      })
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      // 状态
      this.listQuery.strWorkState = !this.isNull(this.statusCheckList)?this.statusCheckList.toString():''
      // console.log('ttt',this.listQuery)
      // this.showDropScreen = -1
      this.getList()
    },
    // 录入简历 选择公有标签
    lPubEnterHandle(val){
      // this.enTagChecks = []
      // console.log('labelEnterHandle', val)
      for (let i = 0; i < val.length; i++) {
        const elementval1 = val[i];
        this.enTagChecks.push(elementval1)
      }
    },
    // 录入简历 选择私有标签
    lPraEnterHandle(val){
      // console.log('lPraEnterHandle', val)
      for (let i = 0; i < val.length; i++) {
        const elementval2 = val[i];
        this.enTagChecks.push(elementval2)
      }
    },
    // 简历导出
    exportHandle(){
      this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
      this.exportQuery.perpage = 1000000
      this.exportQuery.currpage = 1
      if(this.isNull(this.multipleSelection)){
        this.$message({
            message: "请选择要导出的数据",
            type: "warning"
          })
          return false
      }else{
        this.btnLoading = true
        this.exportQuery.stroutid = this.injectQuery.resumeIds
        // type 0 个人资源  1 公海资源  2报名
        xz.outputResumeList('0', this.exportQuery).then(res => {
          if (res.status == 'ok') {
            this.$router.push({
              path: "/resImportList",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                active:'导入导出记录',
                //qStstus=1时查看最后一条导出记录
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          this.btnLoading = false
        })
      }
      
    },
    //获取所有标签列表
    GetLabelManagement() {
      this.laloading = true;
      this.publicList = []
      this.privateList = []
      this.allLabelList = []
      xz.GetLabelManagement(this.roleType).then(res => {
        // console.log('所有', res)
        if (res.status == 'ok') {
          this.publicList = res.data.PublicPersonList;
          this.privateList = res.data.PrivatelyList;
          if(!this.isNull(this.includeLabelChecks)){
            this.includeCheckList01 = this.includeCheckList01.concat(this.includeLabelChecks)
            this.includeCheckList02 = this.includeCheckList02.concat(this.includeLabelChecks)
          }
          if(!this.isNull(this.excludeLabelChecks)){
            this.encludeCheckList01 = this.encludeCheckList01.concat(this.excludeLabelChecks)
            this.encludeCheckList02 = this.encludeCheckList02.concat(this.excludeLabelChecks)
          }
          // labelList = this.publicList.concat(this.privateList)
          // for (let i = 0; i < this.publicList.length; i++) {
          //   const elements1 = this.publicList[i];
            // this.allLabelList = this.allLabelList.concat(elementLabel.LbGroupVallist)
          // }
          // this.allLabelList = [...new Set(this.allLabelList)];s
          // console.log('所有', this.allLabelList)
        }
        this.laloading = false;
      })
    },
    //获取人员列表
    getauthUserInfoByorgancode() {
      xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
        if (res.status == 'ok') {
          if (res.totalcount > 0) {
            this.memberList = res.msg
            // console.log('dd',this.devUserList)
          } else {
            this.memberList = []
          }
        } else {
          this.memberList = []
        }
      })
    },
    // 获取部门列表
    getDepartList(){
      xz.getOrganstrsreach(this.departQuery.strorgancode ,{strIsDisable:'1'}).then(res => {
        // console.log('部门', res)
        if (res.status == 'ok') {
            if(res.msg && res.msg.parent){
              this.departList = res.msg.parent[0].children
            }else {
              this.departList = []
            }
            // console.log('部门', this.departList)
        }
      })
    },
    // 获取表头
    getTableTitleLists(){
      xz.getJbbasePageColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
        if (res.status == 'ok') {
          this.tableTitle = res.msg
          this.getList()
        }else{
          this.tableTitle = []
        }
        // console.log('getList', this.tableTitle)
      })
    },
    // 获取搜索状态
    getStateLists(id){
      xz.getdictdatalistbyid(id).then(res => {
        if (res.status == 'ok') {
          if(id == '92'){
            this.statusList = res.data.retList
          }
          if(id == '118'){
              // 简历来源
              this.originList = res.data.retList
          }
        }
        // console.log('getStateLists', res)
      })
    },
    // 包含标签
    cludeHandle(){
      // this.showMore2 = !this.showMore2
      this.includeSearchVisible = true
      if(!this.isNull(this.includeLabelChecks)){
        this.includeCheckList01 = this.includeCheckList01.concat(this.includeLabelChecks)
        this.includeCheckList02 = this.includeCheckList02.concat(this.includeLabelChecks)
      }
    },
    // 排除标签
    excludeHandle(){
      // this.showMore3 = !this.showMore3
      this.encludeSearchVisible = true
      if(!this.isNull(this.excludeLabelChecks)){
        this.encludeCheckList01 = this.encludeCheckList01.concat(this.excludeLabelChecks)
        this.encludeCheckList02 = this.encludeCheckList02.concat(this.excludeLabelChecks)
      }
    },
    // 获取常用的标签列表
    getCommonlabelLists(){
      xz.getCommonlabelLists({currpage: 1, perpage: 7}).then(res => {
        // console.log('标签', res)
        if (res.status == 'ok') {
          this.includeLabelList = res.msg
          this.excludeLabelList = res.msg
        }else{
          this.includeLabelList = []
          this.excludeLabelList = []
        }
      })
    },
    // 清空
    resetHandle(){
      this.listQuery = this.$options.data.call(this).listQuery
      this.searchQuery.includeContent = ''
      this.searchQuery.encludeContent = ''
      // 当前状态
      this.statusCheckList = []
      // 包含标签
      this.includeLabelChecks = []
      // 排除标签
      this.excludeLabelChecks = []
      this.includeCheckList01 = []
      this.includeCheckList02 = []
      this.encludeCheckList01 = []
      this.encludeCheckList02 = []
    },
    // 分配记录
    divideDtlHandle(){
      let routeUrl = this.$router.resolve({ path: '/divideList',query:{actname:'个人资源'}});
      window.open(routeUrl.href, '_blank');
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    },
    isNullNotZero(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
    }
  }
}
</script>

<style scoped>
.b_txt_com{
  color: #F56C6C;
  font-weight: bold;
}
.com_empty{
  width: 100%;
  padding: 10px;
  color:#666;
  font-size: 14px;
  text-align: center;
}
.r_act_item .com_btn{
  background-color: #19bd92;
  border-color: #19bd92;
  color:#fff;
}
.r_dropDownScreen{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.f_table{
  padding-bottom: 40px;
}
.r_dropDownScreen{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.c_dlt_icon{
  cursor: pointer;
  font-size: 18px;
  color:#F56C6C;
}
.r_label_search .labGroup{
  margin-bottom: 0;
}
.groupname {
  font-size: 14px;
  margin-right: 10px;
}
.banlabel {
  color: #c0c4cc;
}
.r_l_title{
  font-size: 14px;
  color:#333;
  line-height: 25px;
  font-weight: bold;
  border-bottom: 1px dashed #ddd;
}
.form-item input{
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #ccc;
  padding-left: 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 10px;
}
/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display:inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
  top: 5px;
  left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.f_btns{
  display: flex;
  justify-content: flex-end;
}
.f_list_item{
  margin-bottom: 10px;
}
.f_list_item span{
  margin-right: 10px;
}
.r_label_title{
  font-size: 15px;
  color:#409eff;
  font-weight: 500;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}
.r_label_list{
  margin-top: 10px;
}
.labGroup {
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.ftabs {
  background: #fff;
  width: 99%;
}
.r_line_box{
  display: flex;
  align-items: center;
}
.r_line_txt{
  width: 20px;
  height: 1px;
  background-color: #DCDFE6;
  margin: 0 5px;
}
.r_more_box{
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}
.r_more_txt{
  display: inline-block;
  width: 50px;
  margin-right: 5px;
  margin-left: 30px;
  font-size: 13px;
  cursor: pointer;
  color:#409eff;
}
.r_more_txt i{
  font-size: 14px;
  color:#409eff;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(270deg);
}
.res_dialog_popover{
  display: flex;
  justify-content: flex-end;
}
.divide_item{
  margin-bottom: 10px;
  font-size: 14px;
  color:#333
}
.pop_list_box .d_txt02,
.pop_list_box .d_txt03{
  margin-right: 5px;
}
.pop_list_box .d_txt04{
  color:#409eff;
  font-size: 13px;
  text-decoration: underline;
}
.notice_title{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color:#409eff;
  font-size: 14px;
}
.notice_title span{
  cursor: pointer;
}
.notice_title i{
  font-size: 16px;
}
</style>

<style>
.sur_dialog .el-table .cell{
  padding-left: 5px;
  padding-right: 5px;
}
.r_search_box{
    display: flex;
}
.f_all_width .el-form-item__label{
  line-height: 26px;
}
.r_search_sel{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
    height: 26px;
    line-height: 26px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    cursor: pointer;
}
.r_search_sel .r_search_txt{
    flex: 1;
    padding-left: 3px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.r_search_sel i{
    width: 20px;
}
.re_down_form .el-checkbox{
    margin-right: 13px;
}
.r_more_box .dia_label_box{
  flex: 1;
  max-height: 200px;
}
.dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left: 0;
}
.dia_label_box .el-checkbox.is-bordered.is-checked,
.dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #19BD92;
}
.dia_label_box{
  max-height: 400px;
  overflow-y: auto;
}
.r_more_box .dia_label_box .dia_groupname{
  font-weight: normal;
}
.dia_label_box .dia_groupname{
  font-size: 14px;
  line-height: 25px;
  color:#333;
  font-weight: bold;
  margin-top: 5px;
  /* border-bottom: 1px solid #ddd; */
}
.dia_label_box .el-checkbox{
  border: 1px solid #ddd;
  padding: 2px 3px;
  border-radius: 3px;
  height: auto;
  margin: 5px 20px 0 0;
}
.p_resource_module .r_dropDownScreen .el-checkbox__label,
.dia_label_box .el-checkbox__label{
  padding-left: 3px;
}
.disableFirstLevel .el-cascader-panel .el-cascader-menu:first-child .el-cascader-node .el-checkbox{
  display: none;
}
.d_rule_txt01{
  font-size: 13px;
  color:#F56C6C;
  margin-bottom: 10px;
}
.com_dialog_btn.el-button{
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19BD92;
  font-weight: bold;
}
.com_dialog_btn.el-button:hover{
  background-color: #19BD92;
  border: 1px solid #62d2b4;
  color: #fff;
}
.el-tabs__item.is-active {
  color: #19bd92 !important;
}
.d_rule_box{
  margin-top: 3px;
  margin-bottom: 8px;
}
.d_rule_box .txt01{
  font-weight: bold;
  font-size: 14px;
  color:#333;
}
.d_rule_box .txt02{
  font-size: 13px;
  color:#666;
}
.re_dialog_form02 .el-cascader{
  width: 100%;
}
.re_act_box .el-button{
  padding: 4px 8px;
}
.p_resource_module .el-table .com_Selection.cell{
  padding: 0 25px 0 5px;
}
.p_resource_module .el-table .com_Selection.cell .el-checkbox__inner{
  position:relative;
}
.p_resource_module .el-table .com_Selection.cell:before{
  content:"全选";
  position:absolute;
  right:2px;
  top: 1px;
}
.p_resource_module .screenInput .el-select .el-input__inner{
  width: 100%;
}
.re_table.el-table .el-table__cell{
  padding: 3px 0;
}
.re_table.el-table .cell{
  padding: 0 5px;
}
.res_dialog .el-dialog__body {
    padding: 5px 20px 20px 20px;
}
.divide_dialog .el-table .el-table__cell{
  padding: 0;
}
.note_label .el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
.enter_dialog .el-dialog__body{
    padding: 5px 20px 10px 20px;
}
.labGroup .el-checkbox__label {
  padding-left: 3px;
}
.labGroup .el-checkbox {
  margin-right: 20px;
}
.r_act_right{
  display: flex;
  align-items: center;
}
.r_act_right .qrcode_img01{
    width: 25px;
    height: 25px;
    margin-left: 5px;
}
.qrcode_img02{
    width: 200px;
    height: 200px;
    margin-bottom: 5px;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.e_txt_box{
  font-size: 14px;
  color:#409eff;
  text-align: right;
}
.r_act_item .r_txt01{
  font-size: 14px;
  color:#333;
  margin-right: 5px;
}
.r_act_right .r_txt02{
  font-size: 14px;
  color:#409eff;
  margin-left: 8px;
}
.qrcode_box .r_txt03{
  font-size: 14px;
  color:#333;
  text-align: center;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.f_all_width{
  width: 100%;
  align-items: center;
}
.f_checks_box{
  /* line-height: 25px; */
  /* height: 45px; */
  /* overflow: hidden; */
  flex-wrap: wrap;
  flex: 1;
}
.res_dialog .r_more_txt{
  margin-left: 0;
}
.re_down_form.el-form--inline .f_all_width .el-form-item__content{
  width: calc(100% - 100px);
  line-height: 26px;
}
.p_resource_module .screenInput{
  margin: 0 0 10px 5px;
}
.p_resource_module .screenInput .el-input{
  width: 200px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.p_resource_module .re_down_form .el-select,
.p_resource_module .re_down_form .el-cascader,
.p_resource_module .re_down_form.el-form--inline .el-form-item__content{
  width: 225px;
}
.re_down_form .el-form-item{
  margin-bottom: 3px;
  margin-right: 0;
}
.enter_dialog .re_down_form .el-form-item{
  margin-bottom: 20px;
  margin-right: 0;
}
</style>